import axios from "axios";
import jwt_decode from "jwt-decode";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import clipboard from "../../assets/clipboard.svg";
import css from "./noteList.module.css";
// import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import AddCodeModal from "./ICD10Workflow/AddCodeModal";
import CodeSuggestionsModal from "./ICD10Workflow/CodeSuggestionsModal";
import AlternativeCodeModal from "./ICD10Workflow/AlternativeCodeModal";
import DeleteCodeModal from "./ICD10Workflow/DeleteCodeModal";
import EMSection from "./E&M/E&M";
import { useActions, useTriggers, useOnboarding } from "cedar-ui";
import { createPreSurveySteps } from "../WalkthroughShortened";
import { getNoteTemplateForOrg } from "./getNoteTemplateForOrg";
import parseNoteToFields from "./parseNoteToFields";
import noteMapping from "./integuru_note_mapping.json";
import userJSON from "../../utils/userJSON";
import MacrosFeature from "./Macros/MacrosFeature";
import { HelpCircle, X } from "lucide-react";
import sendServerLogging from "../../utils/sendServerLogging.js";

// TODO: implement ketonis rte with custom styling
// TODO: add E&M state variable to pass as prop into E&M component.

// NOTE: react quill rte is commented out for V2-launch d/t issues with AI model and epic copy/paste functionality.

//Allows you to edit the patient and note associated with the patient.
const EditPatient = ({
  patient,
  patientsChange,
  setPatientsChange,
  org,
  superOrg,
  isEditing,
  setIsEditing,
  name,
  generateRecordLink,
  status,
  ehrUploadStatus,
}) => {
  //when we edit the text we update the database
  const [sendTo4D, setSendTo4D] = useState(false);
  const [sendToOncoEMR, setSendToOncoEMR] = useState(false);
  const [sendToAthena, setSendToAthena] = useState(false);
  const [sendToEHR, setSendToEHR] = useState(false);
  const [sendToModMed, setSendToModMed] = useState(false);
  const { callTrigger } = useTriggers();

  const [codesChange, setCodesChange] = useState(false);
  const [showUnspecifiedAlert, setShowUnspecifiedAlert] = useState(false);

  // state variable to show code suggestions modal
  const [showSuggestions, setShowSuggestions] = useState(false);

  //state variable to show add code modal
  const [showAddCode, setShowAddCode] = useState(false);

  const [currentSelectedCode, setCurrentSelectedCode] = useState(null);
  const [historicalCodes, setHistoricalCodes] = useState([]);

  const [isPrimaryCode, setIsPrimaryCode] = useState(false);
  const [isSecondaryCode, setIsSecondaryCode] = useState(false);

  const [userRationale, setUserRationale] = useState("");
  const [mdm_suggested, setMdmSuggestion] = useState("");
  const [mdm_selected, setMDMSelected] = useState("");
  const [mdm_selectedTs, setMDMSelectedTs] = useState(null);
  //state var to display alert for E&M rationale
  const [isRationaleProvided, setIsRationaleProvided] = useState(false);
  const [finalMDMCode, setFinalMDMCode] = useState(null);
  const [finalSelectedLevel, setFinalSelectedLevel] = useState(null);
  const [finalSelectedTs, setFinalSelectedTs] = useState(null);

  const [selectLevelAlert, setSelectLevelAlert] = useState(false);
  const [addRationaleAlert, setAddRationaleAlert] = useState(false);
  const [showRationale, setShowRationale] = useState(false);
  const [recommendedLevel, setRecommendedLevel] = useState(null);

  const [patientSummary, setPatientSummary] = useState("");
  const showPatientSummary = org === "VA" || org === "Knowtex";
  const [copiedSummary, setCopiedSummary] = useState(false);

  const [chartHistory, setChartHistory] = useState([]);

  const calculateFinalMDMCode = (selectedLevel) => {
    // Get visit type modifier (0 for new, 1 for established)
    let visitValue;
    if (patient.visit_type === null || patient.visit_type === "new") {
      visitValue = 0;
    } else {
      visitValue = 1;
    }

    // Calculate the CPT code (992 + visit type + level)
    const cptCode = `992${visitValue}${selectedLevel}`;

    return cptCode;
  };

  useEffect(() => {
    console.log("recalculating code");
    setFinalMDMCode(calculateFinalMDMCode(finalSelectedLevel));
  }, [finalSelectedLevel]);

  const { nextAction } = useActions();
  const {
    activateOnboardingSteps,
    onboardingSteps,
    isOnboardingActive,
    setProgressBar,
  } = useOnboarding();

  // const handleTrigger = async () => {
  //   try {
  //     // Remove the fetch call to /notes/ since it's not needed
  //     // and takes too long to execute
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/dashboard/userinfo`,
  //       {
  //         method: "GET",
  //         headers: { token: localStorage.token },
  //       }
  //     );

  //     const parseRes = await response.json();
  //     // Use user creation date instead of first note date
  //     let userCreatedDate = null;
  //     if (Array.isArray(parseRes) && parseRes.length > 0) {
  //       userCreatedDate = parseRes[0].created_at;
  //     }
  //     let isUserCreatedWithinOneMonth = false;
  //     let isUserCreatedPastWeek = false;
  //     if (userCreatedDate) {
  //       const createdDate = new Date(userCreatedDate);
  //       const now = new Date();
  //       const diffMs = now - createdDate;
  //       const diffDays = diffMs / (1000 * 60 * 60 * 24);
  //       isUserCreatedWithinOneMonth = diffDays < 30;
  //       isUserCreatedPastWeek = diffDays < 7;
  //     }

  //     const wasTriggered = await callTrigger(
  //       "d23d792b-32db-4710-a4bd-5355e7fcd89c"
  //     );
  //     if (wasTriggered) return;

  //     // Post-Use Feedback Survey
  //     if (
  //       !isUserCreatedPastWeek &&
  //       (superOrg === "TenOnc" || superOrg === "Ironwood")
  //     ) {
  //       callTrigger("cbd29207-da8b-4659-95e0-e12fc6c0f50a", (markCompleted) => {
  //         const preSurveySteps = createPreSurveySteps(markCompleted, true);
  //         setProgressBar({
  //           totalValue: preSurveySteps.length,
  //           currentValue: 0,
  //           label: "",
  //         });
  //         activateOnboardingSteps(
  //           preSurveySteps,
  //           "f1b664ce-c0fd-45c1-8115-5352d56023cb"
  //         );
  //       });
  //       return;
  //     }

  //     // NPS Survey
  //     if (!isUserCreatedWithinOneMonth) {
  //       if (superOrg !== "TenOnc") {
  //         callTrigger("9edad124-a958-498d-a0ef-1431bd290c73");
  //       } else {
  //         if (new Date().getHours() >= 17 || new Date().getHours() <= 9) {
  //           callTrigger("9edad124-a958-498d-a0ef-1431bd290c73");
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error triggering:", error);
  //   }
  // };

  const isCurrentCustomer = [
    "4D EMR",
    "cCARE",
    "Astera",
    "PCSRI",
    "MOASD",
    "LACN",
    "CCC",
    "Urgently Ortho",
    "LVOBGYN",
    "Knowtex",
    "VA",
  ];

  const dontShowCodes = [
    "4D EMR",
    "cCARE",
    "PCSRI",
    "MOASD",
    "LACN",
    "CCC",
    "Urgently Ortho",
    "LVOBGYN",
    "Ironwood",
    "Astera", //remove this when astera is ready for icd10 again
  ];

  const navigate = useNavigate();

  const redirectToSettings = () => {
    navigate("/settings");
  };

  //json structure to send to backend
  const mdmSelectedObj = {
    original_selection: mdm_selected,
    original_selection_ts: mdm_selectedTs,
    knowtex_recommendation: mdm_suggested,
    final_level: finalSelectedLevel,
    final_code: finalMDMCode,
    final_selection_ts: finalSelectedTs,
    override_rationale: userRationale,
  };

  const saveNoteOnly = async (id) => {
    //server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "EDIT_NOTE_TEXT_AREA_CLICKED",
        eventData: {},
        patientId: patient.patient_id,
      },
    });

    //         pain_score_details: {
    //           reassessPainInterval,
    //           painScoreOther,
    //           recommendOTCDetails,
    //           prescribedCOX2Details,
    //           prescribedAnxiolyticDetails,
    //           prescribedAntidepressantDetails,
    //           prescribedSteroidalDetails,
    //           prescribedOpioidsDetails,
    //         },
    //         hcc_codes,
    //         cpt_codes,
    //         mdmSelectedObj,
    //         macros,

    try {
      const payload = {
        description,
        note,
        LOSCode,
        codingInfo,
        encounterTime,
        timeBasedCode,
        icd_10_codes: icd_10_codes,
        orders,
        patientData,
        hcc_codes,
        cpt_codes,
        selectedCodes,
        mdmSelectedObj,
        macros,
      };

      const myHeaders = new Headers();

      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      await fetch(`${process.env.REACT_APP_API_URL}/notes/todos/${id}`, {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify(payload),
      });

      // 2) Save *selectedCodes* to DB only now
      await saveSelectedCodes(selectedCodes);

      setPatientsChange(true);

      if (org === "4D EMR") {
        const confirmed = window.confirm(
          "Do you want to send this note to 4D EMR? You will no longer be able to edit it in Knowtex if you do. \n\n" +
            "Notes submitted same day are sent immediately. Notes submitted on subsequent days are synced twice daily at 7AM and 7PM. \n\n" +
            "Click OK to send the note to 4D EMR \n" +
            "Click Cancel to continue editing in Knowtex and send the note to 4D EMR later"
        );
        // handleTrigger();
        setSendTo4D(confirmed);
      }

      if (
        org === "cCARE" ||
        org === "Astera" ||
        org === "Astera Rheumatology" ||
        org === "Astera Breast Surgery" ||
        org === "Astera Pall Care" ||
        org === "astera urology" ||
        org === "Astera Surgery" ||
        org === "Solara" ||
        org === "PCSRI" ||
        org === "PCSRI_Rittenhouse" ||
        org === "LACN" ||
        org === "CCC" ||
        org === "MOASD_V2" ||
        org === "MOASD_V3" ||
        org === "LACN_Gastro" ||
        org === "lacn_gyn_onc" ||
        org === "ccarenp"
        // org === "ironwood medonc" ||
        // org === "ironwood radonc" ||
        // org === "ironwood gyn"
      ) {
        // const confirmed = window.confirm(
        //   "Do you want to send this note to OncoEMR? You will no longer be able to edit it in Knowtex if you do. \n\n" +
        //     "Click OK to send the note to OncoEMR \n" +
        //     "Click Cancel to continue editing in Knowtex and send the note to OncoEMR later"
        // );
        setSendToOncoEMR(true);
        // handleTrigger();
        getAccessTokenAndSendNote();
        // if (confirmed) {
        //   getAccessTokenAndSendNote();
        // }
      }

      if (org === "MedVanta") {
        const confirmed = window.confirm(
          "Do you want to send this note to ModMed? You will no longer be able to edit it in Knowtex if you do. \n\n" +
            "Click OK to send the note to ModMed \n" +
            "Click Cancel to continue editing in Knowtex and send the note to ModMed later"
        );
        setSendToModMed(confirmed);
        // handleTrigger();
        if (confirmed) {
          getAccessTokenAndSendNote();
        }
      }

      if (org === "LVOBGYN") {
        const confirmed = window.confirm(
          "Do you want to send this note to Athena? You will no longer be able to edit it in Knowtex if you do. \n\n" +
            "Click OK to send the note to Athena \n" +
            "Click Cancel to continue editing in Knowtex and send the note to Athena later"
        );
        setSendToAthena(confirmed);
        //handleTrigger();
        if (confirmed) {
          getAccessTokenAndSendNote();
        }
      }

      if (org === "VAAITechSprint" || org === "Knowtex" || org === "VA") {
        // Immediately set status to locked and start EHR upload process
        //setSendToEHR(true);
        changeStatusToLocked();
        changeEHRStatusToUploading();
        setTimeout(() => {
          changeEHRStatusToSuccess();
        }, 5000);
      }
      //server logging: note this will handle both cases when the user clicks upload to ehr or save note.
      sendServerLogging({
        body: {
          ...userJSON(localStorage.getItem("userName")),
          event: "UPLOAD_SAVE_NOTE",
          eventData: { mrn: patient.mrn },
          patientId: patient.patient_id,
        },
      });
    } catch (err) {
      console.error(err.message);
    }
  };

  const hasUnspecifiedIronDeficiencyAnemia = () => {
    const combinedCodes = [...primaryCodes, ...secondaryCodes];

    // Check if any object's .code property is exactly "D50.9" or "D64.9"
    return combinedCodes.some(
      (item) => item.code === "D50.9" || item.code === "D64.9"
    );
  };

  const editText = async (id) => {
    // calculate final MDM code
    setFinalMDMCode(calculateFinalMDMCode(finalSelectedLevel));

    console.log("mdmSelectedObj", mdmSelectedObj);

    try {
      const body = {
        description,
        note,
        LOSCode,
        codingInfo,
        encounterTime,
        timeBasedCode,
        icd_10_codes,
        orders,
        hcc_codes,
        cpt_codes,
        mdmSelectedObj,
        macros,
        pain_score_details: {
          reassessPainInterval,
          painScoreOther,
          recommendOTCDetails,
          prescribedCOX2Details,
          prescribedAnxiolyticDetails,
          prescribedAntidepressantDetails,
          prescribedSteroidalDetails,
          prescribedOpioidsDetails,
        },
      };

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      // Get the updated note information first
      const updatedNoteResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/notes/todos/${id}/updated`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );

      if (!updatedNoteResponse.ok) {
        throw new Error("Failed to fetch updated note");
      }

      const updatedNote = await updatedNoteResponse.json();

      // Update the local state with the new note data
      setDescription(updatedNote.description);
      setNote(updatedNote.note);
      setCodingInfo(updatedNote.coding_information);
      setLOSCode(updatedNote.los_code);
      setEncounterTime(updatedNote.time_spent);
      setTimeBasedCode(updatedNote.time_based_code);
      setICD_10_codes(updatedNote.icd_10_codes);
      setOrders(updatedNote.orders);
      setPatientData(updatedNote.patient_data);
      setDiarizedTranscript(updatedNote.diarized_transcript);
      setDiarizedTranscriptCsvUrl(updatedNote.diarized_transcript_csv_url);
      setCPT_codes(updatedNote.cpt_codes);
      setHCC_Codes(updatedNote.hcc_codes);
      setMacros(updatedNote.macros);
      // Update PAIN SCORE and PHQ data if available
      if (updatedNote.pain_score) setPainScore(updatedNote.pain_score);
      if (updatedNote.pain_score_checks)
        setPainScoreChecks(updatedNote.pain_score_checks);
      if (updatedNote.pain_score_other)
        setPainScoreOther(updatedNote.pain_score_other);
      if (updatedNote.reassess_pain_interval)
        setReassessPainInterval(updatedNote.reassess_pain_interval);

      // Load pain score details if available
      if (updatedNote.pain_score_details) {
        const {
          recommendOTCDetails,
          prescribedCOX2Details,
          prescribedAnxiolyticDetails,
          prescribedAntidepressantDetails,
          prescribedSteroidalDetails,
          prescribedOpioidsDetails,
        } = updatedNote.pain_score_details;

        if (recommendOTCDetails) setRecommendOTCDetails(recommendOTCDetails);
        if (prescribedCOX2Details)
          setPrescribedCOX2Details(prescribedCOX2Details);
        if (prescribedAnxiolyticDetails)
          setPrescribedAnxiolyticDetails(prescribedAnxiolyticDetails);
        if (prescribedAntidepressantDetails)
          setPrescribedAntidepressantDetails(prescribedAntidepressantDetails);
        if (prescribedSteroidalDetails)
          setPrescribedSteroidalDetails(prescribedSteroidalDetails);
        if (prescribedOpioidsDetails)
          setPrescribedOpioidsDetails(prescribedOpioidsDetails);
      }

      if (updatedNote.phq_score) setPhqScore(updatedNote.phq_score);
      if (updatedNote.phq_checks) setPhqChecks(updatedNote.phq_checks);
      if (updatedNote.phq_other) setPhqOther(updatedNote.phq_other);

      // Then save the note
      await fetch(`${process.env.REACT_APP_API_URL}/notes/todos/${id}`, {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify(body),
      });

      // Save selected codes
      await saveSelectedCodes(selectedCodes);

      // Set isEditing to true to prevent polling during save
      setIsEditing(true);

      // Trigger a refresh of the parent component after updating local state
      setPatientsChange(true);

      // Set isEditing back to false after a short delay to allow the save to complete
      setTimeout(() => {
        setIsEditing(false);
      }, 1000);
    } catch (err) {
      console.error(err.message);
      // Make sure to set isEditing back to false even if there's an error
      setIsEditing(false);
    }
  };

  const getAccessTokenAndSendNote = async () => {
    changeEHRStatusToUploading();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dashboard/getaccesstoken`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );

      if (!response.ok) {
        console.log("can't get access token " + response);
        sendSlackNotification("error", {
          error_message:
            "getAccessTokenAndSendNote: Unable to verify credentials to upload note",
          status_code: response.status,
        });
        alert(
          "Unable to verify credentials to upload note. Please try again or contact Knowtex support to resolve this"
        );
        changeStatusToReview();
        changeEHRStatusToIdle();
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Proceed to upload the note if access token is retrieved
      if (data.accessToken) {
        //console.log("access token " + data.accessToken);
        console.log("now about to send note");

        sendNoteViaCobalt(data.accessToken);
      } else {
        console.error("Access token not available.");
        alert(
          "Unable to verify credentials to upload note. Please try again or contact Knowtex support to resolve this"
        );
        changeStatusToReview();
        changeEHRStatusToIdle();
      }
    } catch (error) {
      console.error("Failed to fetch access token:", error);
      changeStatusToReview();
      changeEHRStatusToIdle();
    }
  };

  const sendNoteViaCobalt = async (accessToken) => {
    const formatIcd10Codes = (codes) => {
      // console.log("Initial codes type:", typeof codes);
      //console.log("Initial codes structure:", JSON.stringify(codes, null, 2));

      // If codes is already in the correct format with selected_codes at top level
      if (codes?.selected_codes) {
        console.log("Case 1: Input has selected_codes at top level");
        return codes;
      }

      // If codes has default structure, extract selected_codes
      if (codes?.default?.selected_codes) {
        console.log("Case 2: Input has default structure");
        return {
          selected_codes: codes.default.selected_codes,
        };
      }

      // If codes has just a codes array at top level, wrap it in selected_codes
      if (codes?.codes) {
        console.log(
          "Case 3: Input has codes array at top level, wrapping in selected_codes"
        );
        return {
          selected_codes: codes,
        };
      }

      // Fallback: return default structure with empty codes array
      console.log("Case 4: No matching structure found");
      return {
        selected_codes: {
          codes: [],
        },
      };
    };

    const apiUrl = "https://api.usecobalt.com/v1/notes";

    let bodyData;
    if (
      org !== "4D EMR" &&
      org !== "LVOBGYN" &&
      org !== "cCARE" &&
      org !== "PCSRI" &&
      org !== "MOASD_V3" &&
      org !== "LACN" &&
      org !== "ccarenp" &&
      org !== "lacn_gyn_onc" &&
      org !== "LACN_Gastro" &&
      org !== "Astera" &&
      org !== "Astera Rheumatology" &&
      org !== "Astera Breast Surgery" &&
      org !== "Astera Pall Care" &&
      org !== "astera urology" &&
      org !== "Astera Surgery" &&
      org !== "Solara"
      //org !== "ironwood medonc" &&
      //org !== "ironwood radonc" &&
      //org !== "ironwood gyn"
    ) {
      // Remove the await since formatIcd10Codes is not async
      let icd10Codes = formatIcd10Codes(selectedCodes);
      bodyData = {
        appointment_id: patient.appointment_id,
        appointment_date: patient.date_of_appt,
        mrn: patient.mrn,
        note: note,
        icd_10_codes: icd10Codes,
      };
    } else {
      bodyData = {
        appointment_id: patient.appointment_id,
        appointment_date: patient.date_of_appt,
        mrn: patient.mrn,
        note: note,
      };
    }

    const headers = {
      "Content-Type": "application/json",
      client_id: "ci_live_RRG6m7sZGBWod2xfrhRkw4Ph",
      client_secret: "cs_live_iwoQAkjVRhao7xRbWLLdDUnu",
      access_token: accessToken,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const data = await response.json();
        console.log("Can't upload note: " + data.message);

        sendSlackNotification("error", {
          error_message: `Error sending Note Via Cobalt: ${data.message}`,
          status_code: response.status,
        });
        alert(
          "Unable to upload note at this time. Please try again later or contact Knowtex support to resolve this. Error details: " +
            data.message
        );
        if (
          data.message ===
          "Account link expired. Please go through the integration setup again."
        ) {
          redirectToSettings();
        }
        changeStatusToReview();
        changeEHRStatusToIdle();

        throw new Error(
          "Failed to send note, server response was not ok: " + data.message
        );
      }

      const responseData = await response.json();
      console.log("Response from Cobalt API:", responseData);
    } catch (error) {
      console.error("Error making request:", error);
      changeStatusToReview();
      changeEHRStatusToIdle();
    }
  };

  const integuruGetAccessTokenAndSendNote = async () => {
    changeEHRStatusToUploading();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dashboard/getaccesstoken`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );

      if (!response.ok) {
        console.log("can't get access token " + response);
        sendSlackNotification("error", {
          error_message:
            "integuruGetAccessTokenAndSendNote: Unable to verify credentials to upload note",
          status_code: response.status,
        });
        alert(
          "Unable to verify credentials to upload note. Please try again or contact Knowtex support to resolve this"
        );
        changeStatusToReview();
        changeEHRStatusToIdle();
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Proceed to upload the note if access token is retrieved
      if (data.accessToken) {
        //console.log("access token " + data.accessToken);
        console.log("now about to send note");

        sendNoteViaInteguru(data.accessToken);
      } else {
        console.error("Access token not available.");
        alert(
          "Unable to verify credentials to upload note. Please try again or contact Knowtex support to resolve this"
        );
        changeStatusToReview();
        changeEHRStatusToIdle();
      }
    } catch (error) {
      console.error("Failed to fetch access token:", error);
      changeStatusToReview();
      changeEHRStatusToIdle();
    }
  };

  const sendNoteViaInteguru = async (accessToken) => {
    //need to look at mapping and get the right note required
    let noteTemplateName = "";
    let openedNoteTemplateName = "";
    // Import the utility and use it to get the template
    // (import should be at the top of the file)
    const templateResult = getNoteTemplateForOrg(
      org,
      patient.patient_type,
      name,
      patient
    );
    noteTemplateName = templateResult ? templateResult.template : null;
    console.log("note template name", noteTemplateName);

    // Get note fields directly from the template result
    let noteFields = templateResult ? templateResult.note_field : [];

    const integuruNoteFetchApiUrl =
      "https://production.integuru.ai/oncoemr/catch_all/fields";

    const headers = {
      "Content-Type": "application/json",
      "INTEGURU-TOKEN": accessToken,
    };

    let bodyData;
    bodyData = {
      patient_id: patient.appointment_id, //this is integuru patient id, not knowtex patient id
      note_name: noteTemplateName,
    };

    try {
      let response = await fetch(integuruNoteFetchApiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const data = await response.json();
        console.log("Can't upload note: " + data.message);

        // Send error Slack notification
        await sendSlackNotification("error", {
          error_message: `Error sending note via Integuru: ${data.message}`,
          status_code: response.status,
        });

        // alert(
        //   "Unable to upload note at this time. Please try again later or contact Knowtex support to resolve this. Error details: " +
        //     data.message
        // );
        changeStatusToReview();
        changeEHRStatusToIdle();

        throw new Error(
          "Failed to send note, server response was not ok: " + data.message
        );
      }

      let responseData = await response.json();
      console.log("Response data from fetch:", JSON.stringify(responseData));

      //if note template name returned from the fetch api doesn't match noteTemplateName, set noteTemplateName to the note template name returned from the fetch api
      if (responseData.note_name !== noteTemplateName) {
        openedNoteTemplateName = responseData.note_name;
        console.log(
          "Provider has opened different note template, now using open note template: " +
            openedNoteTemplateName
        );
        await sendSlackNotification("warning", {
          error_message: `Provider has opened different note template, now using open note template: ${openedNoteTemplateName}`,
          status_code: response.status,
        });
        // Get the note_fields for the selected template using our updated function
        const templateResult = getNoteTemplateForOrg(
          org,
          patient.patient_type,
          name,
          patient
        );
        let noteFields = templateResult ? templateResult.note_field : [];

        // If we're using a different template than what our function returned, look it up directly
        if (
          openedNoteTemplateName !==
          (templateResult ? templateResult.template : null)
        ) {
          console.log(
            `Using different template: ${openedNoteTemplateName}, looking up note fields directly`
          );
          const orgObj = noteMapping.org.find((o) => o.org === org);
          if (orgObj) {
            const ptObj = orgObj.patient_type_phrases.find(
              (pt) => pt.template === openedNoteTemplateName
            );
            if (ptObj && ptObj.note_field) {
              noteFields = ptObj.note_field;
            }
          }
        }
        // Dynamically import the parser for the current note template
        let parserFn = null;
        if (openedNoteTemplateName) {
          // Clean template name: trim and remove leading asterisks, then sanitize for file naming
          const cleanedTemplateName = openedNoteTemplateName
            .trim()
            .replace(/^[*]+/, "");
          const parserFileName = `parseNote_${cleanedTemplateName.replace(
            /[^a-zA-Z0-9_]/g,
            "_"
          )}.js`;
          try {
            const parserModule = await import(`./parsers/${parserFileName}`);
            parserFn = parserModule.default;
          } catch (e) {
            console.error(
              `Parser for template ${openedNoteTemplateName} not found:`,
              e
            );
            sendSlackNotification("error", {
              error_message: `Parser for template ${openedNoteTemplateName} not found: ${e.message}`,
              status_code: response.status,
            });
          }
        }
        let parsedSections = {};
        if (parserFn) {
          parsedSections = parserFn(note, noteFields);
          console.log(
            "Parsed note sections with custom parser:",
            JSON.stringify(parsedSections)
          );
        } else {
          // fallback to generic parser if custom not found
          parsedSections = parseNoteToFields(note, noteFields);
          console.log(
            "Parsed note sections with fallback parser:",
            parsedSections
          );
        }
        await formatAndSendNoteToEHR(
          responseData,
          noteFields,
          parsedSections,
          accessToken,
          noteTemplateName
        );
      } else {
        // Use the noteFields we already got from the templateResult
        // No need to look them up again as we already have them from line 687
        // Dynamically import the parser for the current note template
        let parserFn = null;
        if (noteTemplateName) {
          // Clean template name: trim and remove leading asterisks, then sanitize for file naming
          const cleanedTemplateName = noteTemplateName
            .trim()
            .replace(/^[*]+/, "");
          const parserFileName = `parseNote_${cleanedTemplateName.replace(
            /[^a-zA-Z0-9_]/g,
            "_"
          )}.js`;
          try {
            const parserModule = await import(`./parsers/${parserFileName}`);
            parserFn = parserModule.default;
          } catch (e) {
            console.error(
              `Parser for template ${noteTemplateName} not found:`,
              e
            );
          }
        }
        let parsedSections = {};
        if (parserFn) {
          parsedSections = parserFn(note, noteFields);
          console.log(
            "Parsed note sections with custom parser:",
            JSON.stringify(parsedSections)
          );
        } else {
          // fallback to generic parser if custom not found
          parsedSections = parseNoteToFields(note, noteFields);
          console.log(
            "Parsed note sections with fallback parser:",
            parsedSections
          );
        }

        //if successful fetch, use response to send note via Integuru

        await formatAndSendNoteToEHR(
          responseData,
          noteFields,
          parsedSections,
          accessToken,
          noteTemplateName
        );
      }
    } catch (error) {
      console.error("Error making `request to Fetch Note API:", error);
      changeStatusToReview();
      changeEHRStatusToIdle();
    }
  };

  // Helper function to send Slack notifications
  const sendSlackNotification = async (type, additionalData = {}) => {
    try {
      // Extract user_id from JWT
      let user_id = null;
      try {
        const decoded_token = jwt_decode(localStorage.token);
        user_id =
          decoded_token && decoded_token["user"] && decoded_token["user"]["id"];
      } catch (e) {
        console.error("Failed to decode JWT for user_id", e);
      }

      // Prepare Slack payload
      const slackPayload = {
        user_id,
        patient_id: patient.patient_id,
        description: patient.description,
        org,
        mrn: patient.mrn,
        patient_type: patient.patient_type,
        date_of_appt: patient.date_of_appt,
        appointment_id: patient.appointment_id,
        name: name,
        type, // 'success' or 'error'
        ...additionalData,
      };

      await fetch(`${process.env.REACT_APP_API_URL}/api/notify-slack`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(slackPayload),
      });
    } catch (err) {
      console.error("Failed to send Slack notification", err);
    }
  };

  const formatAndSendNoteToEHR = async (
    responseData,
    noteFields,
    parsedSections,
    accessToken,
    noteTemplateName
  ) => {
    // Create a deep copy of the response data with the proper structure
    let updated = {
      ...responseData,
      data: {
        textfields: { ...(responseData.data?.textfields || {}) },
        radio_buttons: { ...(responseData.data?.radio_buttons || {}) },
        checkboxes: { ...(responseData.data?.checkboxes || {}) },
        tables: { ...(responseData.data?.tables || {}) },
        pain_scale: { ...(responseData.data?.pain_scale || {}) },
        phq_scale: { ...(responseData.data?.phq_scale || {}) },
      },
    };

    // Helper to normalize for matching
    const normalize = (str) =>
      str
        .replace(/ Show$/, "")
        .trim()
        .toLowerCase();

    console.log("noteFields:", noteFields);
    console.log("parsedSections keys:", Object.keys(parsedSections));

    // Process each field and ensure it goes into textfields
    for (const field of noteFields) {
      const normField = normalize(field);
      let value = parsedSections[field];

      // Fallback: try to find value by normalized key if not found
      if (value === undefined) {
        const altParsedKey = Object.keys(parsedSections).find(
          (k) => normalize(k) === normField
        );
        if (altParsedKey) value = parsedSections[altParsedKey];
      }

      if (value !== undefined) {
        // Always update the textfields object
        updated.data.textfields[field] = {
          value: value.replace(/\n/g, "<br>"),
          append: false,
        };

        // Remove any duplicate fields that might exist at the root of data
        if (field in updated.data) {
          delete updated.data[field];
        }
      } else {
        console.log(
          `Skipped updating '${field}'; no matching value found in parsedSections.`
        );
      }
    }

    // Process pain scale from the component state (dropdown selection)
    if (painScore) {
      const painScaleValue = parseInt(painScore, 10);
      console.log("painScore raw value:", painScore);
      console.log("painScaleValue from state:", painScaleValue);

      // Initialize pain_scale object with all options set to false if it doesn't exist
      if (!updated.data.pain_scale) {
        updated.data.pain_scale = {
          "0 - No Pain.": false,
          "1 - Very Mild.": false,
          "2 - Discomforting.": false,
          "3 - Tolerating": false,
          "4 - Distressing.": false,
          "5 - Very distressing.": false,
          "6 - Intense pain.": false,
          "7 - Very intense pain.": false,
          "8 - Horrible pain.": false,
          "9 - Excruciating.": false,
          "10 - Unimaginable pain.": false,
        };
      } else {
        // Reset all values to false first
        Object.keys(updated.data.pain_scale).forEach((key) => {
          updated.data.pain_scale[key] = false;
        });
      }

      // Set the corresponding pain scale option to true if it's a valid value (0-10)
      if (painScaleValue >= 0 && painScaleValue <= 10) {
        const painScaleOptions = [
          "0 - No Pain.",
          "1 - Very Mild.",
          "2 - Discomforting.",
          "3 - Tolerating",
          "4 - Distressing.",
          "5 - Very distressing.",
          "6 - Intense pain.",
          "7 - Very intense pain.",
          "8 - Horrible pain.",
          "9 - Excruciating.",
          "10 - Unimaginable pain.",
        ];

        // Set the selected option to true
        const selectedOption = painScaleOptions[painScaleValue];
        updated.data.pain_scale[selectedOption] = true;
        console.log(`Set pain_scale."${selectedOption}" to true`);
      } else {
        console.warn(
          `Invalid pain scale value: ${painScaleValue}. Must be between 0 and 10.`
        );
      }
    }

    // Process PHQ scale from the component state (dropdown selection)
    if (phqScore) {
      console.log("phqScore raw value:", phqScore);

      // Check if phqScore is a valid number or contains a number
      let phqScaleValue;

      // Handle special case for "<5 ~ Negative" first
      if (phqScore.includes("<5")) {
        phqScaleValue = 0; // Use 0 to ensure it falls into the <5 category
      } else if (/\d+/.test(phqScore)) {
        // Extract the first number from the string if it contains a number
        const match = phqScore.match(/(\d+)/);
        phqScaleValue = match ? parseInt(match[1], 10) : NaN;
      } else {
        phqScaleValue = parseInt(phqScore, 10);
      }

      console.log("phqScaleValue from state:", phqScaleValue);

      // Initialize phq_scale object with all options set to false if it doesn't exist
      if (!updated.data.phq_scale) {
        updated.data.phq_scale = {
          "<5 ~ Negative": false,
          "5-9 ~ Minimal Symptoms": false,
          "10-14 ~ Minor Depression": false,
          "15-19 ~ Major Depression, moderately severe": false,
          "20+ ~ Major Depression, severe": false,
        };
      } else {
        // Reset all values to false first
        Object.keys(updated.data.phq_scale).forEach((key) => {
          updated.data.phq_scale[key] = false;
        });
      }

      // Set the corresponding PHQ scale option to true based on the value range
      if (!isNaN(phqScaleValue)) {
        if (phqScaleValue < 5) {
          updated.data.phq_scale["<5 ~ Negative"] = true;
          console.log('Set phq_scale."<5 ~ Negative" to true');
        } else if (phqScaleValue >= 5 && phqScaleValue <= 9) {
          updated.data.phq_scale["5-9 ~ Minimal Symptoms"] = true;
          console.log('Set phq_scale."5-9 ~ Minimal Symptoms" to true');
        } else if (phqScaleValue >= 10 && phqScaleValue <= 14) {
          updated.data.phq_scale["10-14 ~ Minor Depression"] = true;
          console.log('Set phq_scale."10-14 ~ Minor Depression" to true');
        } else if (phqScaleValue >= 15 && phqScaleValue <= 19) {
          updated.data.phq_scale[
            "15-19 ~ Major Depression, moderately severe"
          ] = true;
          console.log(
            'Set phq_scale."15-19 ~ Major Depression, moderately severe" to true'
          );
        } else if (phqScaleValue >= 20) {
          updated.data.phq_scale["20+ ~ Major Depression, severe"] = true;
          console.log('Set phq_scale."20+ ~ Major Depression, severe" to true');
        } else {
          console.warn(
            `PHQ scale value out of expected range: ${phqScaleValue}`
          );
        }
      } else {
        // If phqScore doesn't contain a valid number, try to match it directly with the keys
        console.log(
          "PHQ score is not a valid number, trying to match directly with keys"
        );
        const phqKeys = Object.keys(updated.data.phq_scale);
        const matchingKey = phqKeys.find(
          (key) =>
            phqScore.toLowerCase().includes(key.toLowerCase()) ||
            key.toLowerCase().includes(phqScore.toLowerCase())
        );

        if (matchingKey) {
          updated.data.phq_scale[matchingKey] = true;
          console.log(`Set phq_scale."${matchingKey}" to true by direct match`);
        } else {
          console.warn(
            `Could not match PHQ scale value: ${phqScore} with any key`
          );
        }
      }
    }

    // Helper function to get human-readable labels for checkboxes
    const getCheckboxLabel = (key, type) => {
      // Pain score check labels
      if (type === "pain") {
        switch (key) {
          case "noaction":
            return "No pain - not applicable";
          case "education":
            return "Education";
          case "relaxation":
            return "Relaxation";
          case "applyHeat":
            return "Apply heat";
          case "applyIce":
            return "Apply ice";
          case "Reassesspainat":
            return "Reassess pain at (interval)";
          case "cognitivetherapy":
            return "Cognitive-behavioral therapy";
          case "continuecurrentpainregimen":
            return "Continue current pain regimen";
          case "OTCmed":
            return "Recommend OTC medication";
          case "cox2":
            return "Prescribed COX-2 inhibitor";
          case "anxiolytic":
            return "Prescribed anxiolytic";
          case "antidepressant":
            return "Prescribed antidepressant";
          case "Steriod":
            return "Prescribed steriodal anti-inflammatory";
          case "opioids":
            return "Prescribed opioids";
          case "painmanagement":
            return "Refer to pain management";
          case "radiationtherapy":
            return "Refer to radiation therapy for local XRT";
          case "palliativecare":
            return "Refer to palliative care specialist";
          case "otherintervention":
            return "Other";
          default:
            return key;
        }
      }
      // PHQ check labels
      else if (type === "phq") {
        switch (key) {
          case "supportEducate":
            return "Support, educate, and call if worse";
          case "encourageAerobicActivity":
            return "Encourage aerobic activity";
          case "behavioralActivation":
            return "Behavioral activation";
          case "referToSocialWork":
            return "Refer to social work";
          case "referToChaplaincy":
            return "Refer to chaplaincy";
          case "referToMentalHealthSpecialist":
            return "Refer to mental health specialist";
          case "referToIntegrativeMedicine":
            return "Refer to integrative medicine";
          case "continueCurrentAntidepressant":
            return "Continue current antidepressant";
          case "prescribedAntidepressant":
            return "Prescribed antidepressant";
          case "refertomentalhealthspecialist":
            return "Refer to Mental Health Specialist";
          case "Dir_PCP":
            return "Directed patient to discuss with PCP";
          case "depressionplanother":
            return "Other";
          default:
            return key;
        }
      }
      return key;
    };

    // Process pain score checks and update corresponding checkboxes in the API response
    if (Object.values(painScoreChecks).some((value) => value === true)) {
      console.log("Processing pain score checks:", painScoreChecks);

      // Define mapping between UI checkbox keys and API response checkbox keys
      const painScoreCheckMapping = {
        noaction: "noaction",
        education: "educate",
        relaxation: "relaxation",
        applyHeat: "applyheat",
        applyIce: "applyice",
        reassessPain: "Reassesspainat",
        cognitiveBehavioralTherapy: "cognitivetherapy",
        continueCurrentPainRegimen: "continuecurrentpainregimen",
        recommendOTC: "OTCmed",
        prescribedCOX2: "cox2",
        prescribedAnxiolytic: "anxiolytic",
        prescribedAntidepressant: "antidepressant",
        prescribedSteroidalAntiInflammatory: "steriod",
        prescribedOpioids: "opioids",
        referToPainManagement: "painmanagement",
        referToRadiationTherapy: "radiationtherapy",
        referToPalliativeCare: "palliativecare",
        other: "otherintervention",
      };

      // Ensure checkboxes object exists in the response
      if (!updated.data.checkboxes) {
        updated.data.checkboxes = {};
      }

      // Update checkboxes based on pain score checks
      Object.entries(painScoreChecks).forEach(([key, value]) => {
        const apiKey = painScoreCheckMapping[key];
        if (apiKey && value === true) {
          updated.data.checkboxes[apiKey] = {
            label: getCheckboxLabel(key, "pain"),
            value: true,
          };
          console.log(
            `Set checkbox ${apiKey} to true for pain score check ${key}`
          );
        }
      });

      // Handle reassess pain interval if it exists
      if (painScoreChecks.reassessPain && reassessPainInterval) {
        // This might need to be stored in a different field in the API response
        console.log(`Reassess pain interval: ${reassessPainInterval}`);
      }

      // Handle OTC medication details if it exists
      if (painScoreChecks.recommendOTC && recommendOTCDetails) {
        console.log(`OTC medication details: ${recommendOTCDetails}`);
      }

      // Handle COX-2 inhibitor details if it exists
      if (painScoreChecks.prescribedCOX2 && prescribedCOX2Details) {
        console.log(`COX-2 inhibitor details: ${prescribedCOX2Details}`);
      }

      // Handle anxiolytic details if it exists
      if (painScoreChecks.prescribedAnxiolytic && prescribedAnxiolyticDetails) {
        console.log(`Anxiolytic details: ${prescribedAnxiolyticDetails}`);
      }

      // Handle antidepressant details if it exists
      if (
        painScoreChecks.prescribedAntidepressant &&
        prescribedAntidepressantDetails
      ) {
        console.log(
          `Antidepressant details: ${prescribedAntidepressantDetails}`
        );
      }

      // Handle steroidal anti-inflammatory details if it exists
      if (
        painScoreChecks.prescribedSteroidalAntiInflammatory &&
        prescribedSteroidalDetails
      ) {
        console.log(
          `Steroidal anti-inflammatory details: ${prescribedSteroidalDetails}`
        );
      }

      // Handle opioids details if it exists
      if (painScoreChecks.prescribedOpioids && prescribedOpioidsDetails) {
        console.log(`Opioids details: ${prescribedOpioidsDetails}`);
      }

      // Handle pain score other if it exists
      if (painScoreChecks.other && painScoreOther) {
        // This might need to be stored in a different field in the API response
        console.log(`Pain score other: ${painScoreOther}`);
      }
    }

    // Process PHQ checks and update corresponding checkboxes in the API response
    if (Object.values(phqChecks).some((value) => value === true)) {
      console.log("Processing PHQ checks:", phqChecks);

      // Define mapping between UI checkbox keys and API response checkbox keys
      const phqCheckMapping = {
        supporteducatetocallifworse: "supporteducatetocallifworse",
        encourageaerobicactivity: "encourageaerobicactivity",
        behavioralactivation: "behavioralactivation",
        Psychotherapy: "Psychotherapy",
        refertochaplain: "refertochaplain",
        refertomentalhealthspecialist: "refertomentalhealthspecialist",
        refertointegrativemedicine: "refertointegrativemedicine",
        continuecurrentantidepressant: "continuecurrentantidepressant",
        prescribedantidepressant: "prescribedantidepressant",
        Dir_PCP: "Dir_PCP",
        Dir_menprov: "Dir_menprov",
        depressionplanother: "depressionplanother",
      };

      // Ensure checkboxes object exists in the response
      if (!updated.data.checkboxes) {
        updated.data.checkboxes = {};
      }

      // Update checkboxes based on PHQ checks
      Object.entries(phqChecks).forEach(([key, value]) => {
        const apiKey = phqCheckMapping[key];
        if (apiKey && value === true) {
          updated.data.checkboxes[apiKey] = {
            label: getCheckboxLabel(key, "phq"),
            value: true,
          };
          console.log(`Set checkbox ${apiKey} to true for PHQ check ${key}`);
        }
      });

      // Process PHQ score other if present from patient data
      const phqScoreOther = patientData?.chart_history?.phq_score_other || "";
      if (phqScoreOther && phqScoreOther.trim() !== "") {
        updated.data.textfields["PHQ_other"] = {
          value: phqScoreOther,
          append: false,
        };
      }
    }

    // Process fax recipients if available
    if (faxRecipients && faxRecipients.length > 0) {
      console.log("Processing fax recipients:", faxRecipients);

      // Format recipients for structured data storage using the original structure with updated values
      const formattedRecipients = faxRecipients.map((recipient) => {
        return {
          type: recipient.type,
          name: recipient.name,
          phone: recipient.phone,
          inactive: recipient.inactive,
          // Use the original checkboxes array with updated values
          checkboxes: recipient.originalCheckboxes.map((checkbox) => {
            if (checkbox.column === "all") {
              return {
                ...checkbox,
                value: recipient.all,
              };
            } else if (checkbox.column === "summary_only") {
              return {
                ...checkbox,
                value: recipient.summaryOnly,
              };
            }
            return checkbox;
          }),
        };
      });

      // Store the structured data in the expected format - in tables.FaxRecipients instead of fax_recipients
      if (!updated.data.tables) {
        updated.data.tables = {};
      }
      updated.data.tables.FaxRecipients = formattedRecipients;

      // Log the formatted recipients for debugging
      console.log(
        "Formatted fax recipients for submission:",
        formattedRecipients
      );

      console.log(
        "Formatted fax recipients for submission:",
        formattedRecipients
      );
    }

    // Helper function to format date as MM/DD/YYYY
    const formatDateToMMDDYYYY = (dateStr) => {
      // Example input: "Thursday, May 8, 2025"
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };

    if (patient.date_of_appt) {
      const createdOn = formatDateToMMDDYYYY(patient.date_of_appt);
      // Insert as third field
      const newUpdated = {};
      const keys = Object.keys(updated);
      // Always keep patient_id and note_name first if present
      if (keys.includes("patient_id"))
        newUpdated.patient_id = updated.patient_id;
      if (keys.includes("note_name")) newUpdated.note_name = updated.note_name;
      newUpdated.created_on = createdOn;
      // Add the rest, skipping created_on if it already existed
      for (const k of keys) {
        if (k !== "patient_id" && k !== "note_name" && k !== "created_on") {
          newUpdated[k] = updated[k];
        }
      }
      updated = newUpdated;
    }

    // Format the updated JSON before sending
    const formatJsonWithBreaks = (
      await import("../../utils/formatJsonWithBreaks")
    ).default;
    const formatted = formatJsonWithBreaks(updated);
    console.log("Formatted JSON:", formatted);

    // RK OV Note 1: Dr. Kukunoor append logic
    if (
      (noteTemplateName === "RK OV Note 1" ||
        noteTemplateName === "*MO Telemedicine Note") &&
      name === "Dr. Kukunoor"
    ) {
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }
      // Set append = true for HPI_IH
      if (!formatted.data.textfields["HPI_IH"]) {
        console.log(
          'Section heading "HPI_IH" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI_IH"] !== "object") {
        console.log(
          'Section heading "HPI_IH" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI_IH"].append = true;
      }
      //pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    // *MD Office Visit Victor Chiu v3: Dr. Chiu append logic for HPI
    if (
      noteTemplateName === "*MD Office Visit Victor Chiu v3" &&
      name === "Dr. Chiu"
    ) {
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }
      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }

      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    // Breast Office Visit RPV append assessment, imaging, pathology
    if (
      noteTemplateName === "Breast Office Visit RPV" &&
      name === "Rashmi Vaidya"
    ) {
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }
      // Set append = true for Assessment
      if (!formatted.data.textfields["Assessment_Sur"]) {
        console.log(
          'Section heading "Assessment_Sur" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (
        typeof formatted.data.textfields["Assessment_Sur"] !== "object"
      ) {
        console.log(
          'Section heading "Assessment_Sur" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Assessment_Sur"].append = true;
      }

      // Set append = true for Imaging
      if (!formatted.data.textfields["RAD_no"]) {
        console.log(
          'Section heading "RAD_no" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["RAD_no"] !== "object") {
        console.log(
          'Section heading "RAD_no" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["RAD_no"].append = true;
      }

      //Set append = true for Pathology
      if (!formatted.data.textfields["OSL"]) {
        console.log(
          'Section heading "OSL" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["OSL"] !== "object") {
        console.log(
          'Section heading "OSL" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["OSL"].append = true;
      }
    }

    if (
      noteTemplateName === "MD Visit Note From LIU" &&
      name === "Dr. Ziyang Liu"
    ) {
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }
      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }

      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (
      noteTemplateName === "MD Office Visit Note RJB" &&
      name === "Dr. Rajesh Bagai"
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (
      noteTemplateName === "*MO Follow up Visit" &&
      name === "Dr. Luke Halbur"
    ) {
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (
      noteTemplateName === "MD Office Visit Note RKB" &&
      name === "Dr. Rakesh Bagai"
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (
      noteTemplateName === "*MD Office Visit Note Form 3" &&
      (patient.patient_type === "fu" ||
        patient.patient_type == null || // covers null and undefined
        patient.patient_type === "")
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (noteTemplateName === "MD Office Visit Note SS") {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI_SS
      if (!formatted.data.textfields["HPI_SS"]) {
        console.log(
          'Section heading "HPI_SS" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI_SS"] !== "object") {
        console.log(
          'Section heading "HPI_SS" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI_SS"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology_SS"]) {
        console.log(
          'Section heading "Pathology_SS" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (
        typeof formatted.data.textfields["Pathology_SS"] !== "object"
      ) {
        console.log(
          'Section heading "Pathology_SS" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology_SS"].append = true;
      }
    }

    if (
      noteTemplateName === "*MD Office Visit Note Form 4" &&
      (patient.patient_type === "fu" ||
        patient.patient_type == null || // covers null and undefined
        patient.patient_type === "")
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append to true for HPI
      if (formatted.data.textfields["HPI"]) {
        if (typeof formatted.data.textfields["HPI"] === "object") {
          formatted.data.textfields["HPI"].append = true;
        } else {
          console.log(
            'Section heading "HPI" is not an object; cannot update append key.'
          );
        }
      } else {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      }

      // Set append to true for Pathology
      if (formatted.data.textfields["Pathology"]) {
        if (typeof formatted.data.textfields["Pathology"] === "object") {
          formatted.data.textfields["Pathology"].append = true;
        } else {
          console.log(
            'Section heading "Pathology" is not an object; cannot update append key.'
          );
        }
      }
    }

    if (
      noteTemplateName === "*MD Office Visit Note Form 1" &&
      (patient.patient_type === "fu" ||
        patient.patient_type == null || // covers null and undefined
        patient.patient_type === "")
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }

      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (
      noteTemplateName === "*MO Follow up Visit 2" &&
      (patient.patient_type === "fu" ||
        patient.patient_type == null || // covers null and undefined
        patient.patient_type === "")
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }

      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    // GYN Office Visit Note: Set append to true for 'Imaging Results Show - Radiology' and 'Pathology'
    if (noteTemplateName === "GYN Office Visit Note") {
      const gynSections = ["RAD_noMJP", "Path_MJP"];

      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      gynSections.forEach((section) => {
        if (!formatted.data.textfields[section]) {
          console.log(
            `Section heading '${section}' not found in formatted.data.textfields; cannot update append key.`
          );
        } else if (typeof formatted.data.textfields[section] !== "object") {
          console.log(
            `Section heading '${section}' is not an object; cannot update append key.`
          );
        } else {
          formatted.data.textfields[section].append = true;
        }
      });
    }

    if (
      (noteTemplateName === "*MO Telemedicine Note" ||
        noteTemplateName === "MO Telemedicine Note LIU" ||
        noteTemplateName === "MO Telemedicine Note RKB") &&
      patient.patient_type === "telemed"
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI"] !== "object") {
        console.log(
          'Section heading "HPI" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology"]) {
        console.log(
          'Section heading "Pathology" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["Pathology"] !== "object") {
        console.log(
          'Section heading "Pathology" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology"].append = true;
      }
    }

    if (noteTemplateName === "MD Telehealth Visit Note SS") {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI
      if (!formatted.data.textfields["HPI_SS"]) {
        console.log(
          'Section heading "HPI" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI_SS"] !== "object") {
        console.log(
          'Section heading "HPI_SS" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI_SS"].append = true;
      }
      // Set append = true for Pathology
      if (!formatted.data.textfields["Pathology_SS"]) {
        console.log(
          'Section heading "Pathology_SS" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (
        typeof formatted.data.textfields["Pathology_SS"] !== "object"
      ) {
        console.log(
          'Section heading "Pathology_SS" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["Pathology_SS"].append = true;
      }
    }

    if (
      noteTemplateName === "*RO TELEMED 1" &&
      patient.patient_type === "telemed"
    ) {
      // Set append to true in 'History of Present Illness' if it exists
      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      // Set append = true for HPI_RO
      if (!formatted.data.textfields["HPI_RO"]) {
        console.log(
          'Section heading "HPI_RO" not found in formatted.data.textfields; cannot update append key.'
        );
      } else if (typeof formatted.data.textfields["HPI_RO"] !== "object") {
        console.log(
          'Section heading "HPI_RO" is not an object; cannot update append key.'
        );
      } else {
        formatted.data.textfields["HPI_RO"].append = true;
      }
    }

    if (
      noteTemplateName === "GYN Telemedicine Note" &&
      patient.patient_type === "telemed"
    ) {
      // Set append to true in 'HPI_MJP', 'RAD_noMJP', and 'Path_MJP' if they exist
      const appendFields = ["HPI_MJP", "RAD_noMJP", "Path_MJP"];

      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      appendFields.forEach((field) => {
        if (!formatted.data.textfields[field]) {
          console.log(
            `Section heading "${field}" not found in formatted.data.textfields; cannot update append key.`
          );
        } else if (typeof formatted.data.textfields[field] !== "object") {
          console.log(
            `Section heading "${field}" is not an object; cannot update append key.`
          );
        } else {
          formatted.data.textfields[field].append = true;
        }
      });
    }

    // Emily Ho append logic for HPI, RAD, and Path
    if (noteTemplateName === "Breast Office Visit Note HO") {
      // Set append to true in 'HPI_HO', 'RAD_noHO', and 'Path_HO' if they exist
      const appendFields = [
        "HPI_HO",
        "RAD_noHO",
        "Path_HO",
        "PastMedicalHistoryHO",
        "PastSurgicalHistoryHO",
        "FamilyHistoryHO",
        "SH_NCHO",
        "GynHistoryHO",
      ];

      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      appendFields.forEach((field) => {
        if (!formatted.data.textfields[field]) {
          console.log(
            `Section heading "${field}" not found in formatted.data.textfields; cannot update append key.`
          );
        } else if (typeof formatted.data.textfields[field] !== "object") {
          console.log(
            `Section heading "${field}" is not an object; cannot update append key.`
          );
        } else {
          formatted.data.textfields[field].append = true;
        }
      });
    }

    // Emily Ho telemed append logic for HPI, RAD, and Path
    if (noteTemplateName === "Breast Telemed Note HO") {
      // Set append to true in 'HPI_HO', 'RAD_noHO', and 'Path_HO' if they exist
      const appendFields = ["HPI_HO", "RAD_noHO", "Path_HO"];

      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      appendFields.forEach((field) => {
        if (!formatted.data.textfields[field]) {
          console.log(
            `Section heading "${field}" not found in formatted.data.textfields; cannot update append key.`
          );
        } else if (typeof formatted.data.textfields[field] !== "object") {
          console.log(
            `Section heading "${field}" is not an object; cannot update append key.`
          );
        } else {
          formatted.data.textfields[field].append = true;
        }
      });
    }

    // KTEX: Set append to true for 'History of Present Illness', 'Treatment Summary,' 'Imaging Results Show - Radiology', and 'Pathology'
    const ktexTemplates = [
      "(KTEX) MD Follow Up",
      "(KTEX) MD DDU Follow Up",
      "(KTEX) MD New/Comprehensive Follow-up Note v1",
      "(KTEX) DDU New/Comprehensive Follow-up Note v1",
      "(KTEX) MD TOCBC New/Comprehensive Follow-up v1",
      "(KTEX) MD TOCBC v1",
    ];

    if (ktexTemplates.includes(noteTemplateName)) {
      const ktexSections = [
        "HPI",
        "md_ts_",
        "labresult1",
        "OSL",
        "ddu_md_ts_",
        "SCCBCmd_ts_",
        "SCCBCHPI",
      ];

      if (!formatted.data || !formatted.data.textfields) {
        console.log(
          "formatted.data or formatted.data.textfields is undefined; cannot update append key."
        );
        return;
      }

      ktexSections.forEach((section) => {
        if (!formatted.data.textfields[section]) {
          console.log(
            `Section heading '${section}' not found in formatted.data.textfields; cannot update append key.`
          );
        } else if (typeof formatted.data.textfields[section] !== "object") {
          console.log(
            `Section heading '${section}' is not an object; cannot update append key.`
          );
        } else {
          formatted.data.textfields[section].append = true;
        }
      });
      // If patient_type is 'telemed', clear the Physical Exam_ field
      if (
        patient.patient_type === "telemed" &&
        formatted.data &&
        formatted.data.textfields &&
        typeof formatted.data.textfields["Physical Exam_"] === "object"
      ) {
        formatted.data.textfields["Physical Exam_"].value = "";
      }
    }

    const integuruNoteSubmitApiUrl =
      "https://production.integuru.ai/oncoemr/catch_all/submit";

    const headers = {
      "Content-Type": "application/json",
      "INTEGURU-TOKEN": accessToken,
    };

    try {
      const response = await fetch(integuruNoteSubmitApiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formatted),
      });

      console.log("Submit API response:", response.status);

      if (response.ok) {
        // Send success Slack notification (🔬)
        await sendSlackNotification("success", {
          note,
          noteTemplateName,
          patient,
          org,
          name,
          accessToken,
        });
        //change ehr_upload_status to success
        changeEHRStatusToSuccess();
      } else {
        // Handle non-200 responses
        let errorMessage = `HTTP ${response.status}`;
        try {
          const responseText = await response.text();
          if (responseText) {
            errorMessage += `: ${responseText}`;
          }
        } catch (e) {
          console.error("Failed to read error response text", e);
        }

        // Send error Slack notification
        await sendSlackNotification("error", {
          error_message: `Error sending note to EHR: ${errorMessage}`,
          status_code: response.status,
        });

        changeStatusToReview();
        changeEHRStatusToIdle();
      }
    } catch (error) {
      console.error("Error making request to Submit Note API:", error);

      // Send error Slack notification for network/fetch errors
      await sendSlackNotification("error", {
        error_message: `Error sending note to EHR: ${
          error.message || "Network error"
        }`,
        status_code: "Network Error",
      });

      changeStatusToReview();
      changeEHRStatusToIdle();
    }
  };

  const handleSendTo4D = async () => {
    if (!sendTo4D) return;

    changeStatusToLocked();

    setSendTo4D(false);
  };

  useEffect(() => {
    handleSendTo4D();
  }, [sendTo4D]);

  const handleSendToOncoEMR = async () => {
    if (!sendToOncoEMR) return;

    changeStatusToLocked();

    setSendToOncoEMR(false);
  };

  useEffect(() => {
    handleSendToOncoEMR();
  }, [sendToOncoEMR]);

  const handleSendToAthena = async () => {
    if (!sendToAthena) return;

    changeStatusToLocked();

    setSendToAthena(false);
  };

  // swapped these so they don't conflict
  useEffect(() => {
    handleSendToModMed();
  }, [sendToModMed]);

  const handleSendToModMed = async () => {
    if (!sendToModMed) return;
    changeStatusToLocked();
    setSendToModMed(false);
  };

  useEffect(() => {
    handleSendToAthena();
  }, [sendToAthena]);

  const changeEHRStatusToUploading = async () => {
    try {
      const ehr_status = "uploading"; // Changed from ehrStatus to ehr_status
      const body = { ehr_status }; // Ensure the key matches the backend

      const myHeaders = new Headers();

      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/notes/ehr_upload_status/${patient.patient_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to update EHR status:", errorText);
        //alert("Failed to update EHR status. Please try again.");
        sendSlackNotification("error", {
          error_message: "Failed to update EHR status. Please try again.",
          status_code: response.status,
        });
        return;
      }

      console.log("EHR Upload Status changed to 'uploading'");
    } catch (err) {
      console.error("Error in changeEHRStatusToUploading:", err.message);
      //alert("An error occurred while updating EHR status.");
    }
  };

  const changeEHRStatusToSuccess = async () => {
    try {
      const ehr_status = "success"; // Changed from ehrStatus to ehr_status
      const body = { ehr_status }; // Ensure the key matches the backend

      const myHeaders = new Headers();

      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/notes/ehr_upload_status/${patient.patient_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to update EHR status:", errorText);
        //alert("Failed to update EHR status. Please try again.");
        sendSlackNotification("error", {
          error_message: "Failed to update EHR status. Please try again.",
          status_code: response.status,
        });
        return;
      }

      console.log("EHR Upload Status changed to 'success'");
    } catch (err) {
      console.error("Error in changeEHRStatusToSuccess:", err.message);
      //alert("An error occurred while updating EHR status.");
    }
  };

  const changeEHRStatusToIdle = async () => {
    try {
      const ehr_status = "idle"; // Changed from ehrStatus to ehr_status
      const body = { ehr_status }; // Ensure the key matches the backend

      const myHeaders = new Headers();

      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/notes/ehr_upload_status/${patient.patient_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to update EHR status:", errorText);
        //alert("Failed to update EHR status. Please try again.");
        sendSlackNotification("error", {
          error_message: "Failed to update EHR status. Please try again.",
          status_code: response.status,
        });
        return;
      }

      console.log("EHR Upload Status changed to 'idle'");
    } catch (err) {
      console.error("Error in changeEHRStatusToIdle:", err.message);
      //alert("An error occurred while updating EHR status.");
    }
  };

  const changeStatusToLocked = async () => {
    try {
      const status = "Locked";
      const body = { status };

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      // 1. Lock the note
      await fetch(
        `${process.env.REACT_APP_API_URL}/notes/status/${patient.patient_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );
    } catch (err) {
      console.error(err.message);
    }
  };

  const changeStatusToReview = async () => {
    try {
      const status = "Review";
      //console.log(status);
      const body = { status };

      const myHeaders = new Headers();

      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("token", localStorage.token);

      await fetch(
        `${process.env.REACT_APP_API_URL}/notes/status/${patient.patient_id}`,
        {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );
      //console.log("Status changed");
    } catch (err) {
      console.error(err.message);
    }
  };

  const sendButtonClickedSlackNotification = async () => {
    console.log("sendNotification CALLED", new Date().toISOString());
    // 2. Extract user_id from JWT
    let user_id = null;
    try {
      const decoded_token = jwt_decode(localStorage.token);
      user_id =
        decoded_token && decoded_token["user"] && decoded_token["user"]["id"];
    } catch (e) {
      console.error("Failed to decode JWT for user_id", e);
    }

    // 3. Prepare data for Slack notification
    const slackPayload = {
      user_id,
      patient_id: patient.patient_id,
      description: patient.description,
      org,
      mrn: patient.mrn,
      patient_type: patient.patient_type,
      note,
      message: "Send to EHR clicked",
      name,
      date_of_appt: patient.date_of_appt,
      appointment_id: patient.appointment_id,
    };

    // 4. Send notification to backend endpoint
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/notify-slack`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(slackPayload),
      });
    } catch (err) {
      console.error("Failed to send Slack notification", err);
    }
  };
  // Function to send log when user clicked 'Review Note'
  function log_review_note(patient_id) {
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "REVIEW_NOTE",
        eventData: { mrn: patient.mrn },
        patientId: patient_id,
      },
    });
  }

  // function to send log and metrics when user clicks icd10 code button
  function code_click(patient_id) {
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "ICD_10_CODE_CLICK",
        eventData: { mrn: patient.mrn },
        patientId: patient_id,
      },
    });
  }

  // function to send logs and metrics for when user is editing/modifying icd-10 codes.
  function modifying_codes_click(patient_id) {
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "MODIFIED_ICD_10_CODE",
        eventData: { mrn: patient.mrn },
        patientId: patient_id,
      },
    });
  }

  async function onCopy(patient_id) {
    setIsCopied(true);

    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "NOTE_COPIED",
        eventData: { mrn: patient.mrn },
        patientId: patient_id,
      },
    });
  }

  const formatICD10Codes = (icd10Data) => {
    if (!icd10Data) return "";

    // Check if selected_codes is a string. If so, parse it.
    let selectedCodesInit;
    if (typeof icd10Data.selected_codes === "string") {
      try {
        selectedCodesInit = JSON.parse(icd10Data.selected_codes);
      } catch (err) {
        console.error("Failed to parse selected_codes JSON:", err);
        return { icd10Data };
      }
    } else {
      selectedCodesInit = icd10Data.selected_codes;
    }

    // Ensure codes is an array
    if (!selectedCodesInit || !Array.isArray(selectedCodesInit.codes)) {
      return { icd10Data };
    }

    // Set historical codes if they exist
    if (icd10Data.historical) {
      //console.log("historical codes", icd10Data.historical);
      // Create a flat array of all historical codes
      const flatHistoricalCodes = [
        ...(icd10Data.historical.primary || []),
        ...(icd10Data.historical.secondary || []),
        ...(icd10Data.historical.active || []),
      ];
      setHistoricalCodes(flatHistoricalCodes);
      // Filter out historical codes from the codes array
      selectedCodesInit.codes = selectedCodesInit.codes.filter(
        (code) => !flatHistoricalCodes.includes(code.code)
      );
    }

    console.log("selectedCodesInit", selectedCodesInit);
    return selectedCodesInit;
  };

  // Helper functions for orders parsing and formatting
  const parseOrdersFromString = (ordersString) => {
    if (!ordersString || ordersString.trim() === "") {
      return [];
    }

    const orders = [];
    const lines = ordersString.split("\n");
    let orderId = 1;

    for (const line of lines) {
      const trimmedLine = line.trim();
      if (!trimmedLine) continue;

      // Handle the format: "test_name: value, test_due_duration: value, estimated_test_due_date: value"
      // OR the format: "sugar level check, test_due_duration: today, estimated_test_due_date:"

      let currentOrder = { id: orderId++ };

      if (trimmedLine.includes("test_name:")) {
        // Standard format with test_name: prefix
        const testNameMatch = trimmedLine.match(/test_name:\s*([^,]+)/);
        const durationMatch = trimmedLine.match(/test_due_duration:\s*([^,]+)/);
        const dateMatch = trimmedLine.match(
          /estimated_test_due_date:\s*([^,]*)/
        );

        if (testNameMatch) currentOrder.test_name = testNameMatch[1].trim();
        if (durationMatch)
          currentOrder.test_due_duration = durationMatch[1].trim();
        if (dateMatch)
          currentOrder.estimated_test_due_date = dateMatch[1].trim();
      } else {
        // Handle format like "sugar level check, test_due_duration: today, estimated_test_due_date:"
        const parts = trimmedLine.split(",");

        for (let i = 0; i < parts.length; i++) {
          const part = parts[i].trim();

          if (part.includes("test_due_duration:")) {
            currentOrder.test_due_duration = part
              .replace("test_due_duration:", "")
              .trim();
          } else if (part.includes("estimated_test_due_date:")) {
            currentOrder.estimated_test_due_date = part
              .replace("estimated_test_due_date:", "")
              .trim();
          } else if (i === 0 && !part.includes(":")) {
            // First part without colon is likely the test name
            currentOrder.test_name = part;
          }
        }
      }

      // Only add if we have at least a test name
      if (currentOrder.test_name) {
        orders.push(currentOrder);
      }
    }

    return orders;
  };

  const formatOrdersToString = (orders) => {
    if (!orders || orders.length === 0) {
      return "";
    }

    return orders
      .map((order) => {
        const lines = [];
        if (order.test_name) {
          lines.push(`test_name: ${order.test_name}, `);
        }
        if (order.test_due_duration) {
          lines.push(`test_due_duration: ${order.test_due_duration}, `);
        }
        if (order.estimated_test_due_date) {
          lines.push(
            `estimated_test_due_date: ${order.estimated_test_due_date}`
          );
        }
        return lines.join("");
      })
      .join("\n");
  };

  const [description, setDescription] = useState("");

  // Section highlighting state
  const [selectedSectionWords, setSelectedSectionWords] = useState([]);
  const [highlightedTranscript, setHighlightedTranscript] = useState("");

  // Helper function to extract section content from note
  const extractSectionContent = (noteText, sectionName) => {
    if (!noteText) return "";

    const sectionRegex = new RegExp(
      `${sectionName}:\\s*([\\s\\S]*?)(?=\\n\\s*(?:ASSESSMENT|PLAN|SUBJECTIVE|OBJECTIVE):|$)`,
      "i"
    );
    const match = noteText.match(sectionRegex);

    if (match && match[1]) {
      return match[1].trim();
    }
    return "";
  };

  // Medical abbreviations dictionary
  const medicalAbbreviations = {
    dm: "diabetes mellitus",
    htn: "hypertension",
    cad: "coronary artery disease",
    copd: "chronic obstructive pulmonary disease",
    chf: "congestive heart failure",
    mi: "myocardial infarction",
    cvd: "cardiovascular disease",
    sob: "shortness of breath",
    doe: "dyspnea on exertion",
    cp: "chest pain",
    bp: "blood pressure",
    hr: "heart rate",
    rr: "respiratory rate",
    temp: "temperature",
    wt: "weight",
    ht: "height",
    bmi: "body mass index",
    a1c: "hemoglobin a1c",
    hgb: "hemoglobin",
    hct: "hematocrit",
    wbc: "white blood cell",
    rbc: "red blood cell",
    plt: "platelet",
    bun: "blood urea nitrogen",
    cr: "creatinine",
    gfr: "glomerular filtration rate",
    ldl: "low density lipoprotein",
    hdl: "high density lipoprotein",
    tg: "triglycerides",
    tsh: "thyroid stimulating hormone",
    t4: "thyroxine",
    pt: "prothrombin time",
    ptt: "partial thromboplastin time",
    inr: "international normalized ratio",
    ekg: "electrocardiogram",
    ecg: "electrocardiogram",
    cxr: "chest x-ray",
    ct: "computed tomography",
    mri: "magnetic resonance imaging",
    us: "ultrasound",
    pe: "physical examination",
    hpi: "history of present illness",
    pmh: "past medical history",
    psh: "past surgical history",
    fh: "family history",
    sh: "social history",
    ros: "review of systems",
    nkda: "no known drug allergies",
    nka: "no known allergies",
    prn: "as needed",
    bid: "twice daily",
    tid: "three times daily",
    qid: "four times daily",
    qd: "once daily",
    qhs: "at bedtime",
    ac: "before meals",
    pc: "after meals",
    po: "by mouth",
    iv: "intravenous",
    im: "intramuscular",
    sq: "subcutaneous",
    sl: "sublingual",
  };

  // Medical phrases dictionary (multi-word terms)
  const medicalPhrases = [
    "diabetes mellitus",
    "type 1 diabetes",
    "type 2 diabetes",
    "blood pressure",
    "heart rate",
    "chest pain",
    "shortness of breath",
    "myocardial infarction",
    "coronary artery disease",
    "congestive heart failure",
    "chronic obstructive pulmonary disease",
    "acute myocardial infarction",
    "atrial fibrillation",
    "ventricular tachycardia",
    "pulmonary embolism",
    "deep vein thrombosis",
    "kidney disease",
    "liver disease",
    "thyroid disease",
    "brain fog",
    "blurry vision",
    "weight loss",
    "weight gain",
    "abdominal pain",
    "back pain",
    "joint pain",
    "muscle pain",
    "head pain",
    "neck pain",
    "leg pain",
    "arm pain",
    "chronic pain",
    "acute pain",
    "blood sugar",
    "blood glucose",
    "insulin resistance",
    "metabolic syndrome",
    "sleep apnea",
    "acid reflux",
    "gastroesophageal reflux",
    "irritable bowel",
    "inflammatory bowel",
    "urinary tract infection",
    "kidney stones",
    "gallbladder disease",
    "liver function",
    "kidney function",
    "heart function",
    "lung function",
    "thyroid function",
    "adrenal function",
  ];

  // Helper function to extract words and phrases from section content
  const extractWordsFromSection = (sectionContent) => {
    if (!sectionContent) return [];

    const cleanedContent = sectionContent
      .replace(/[\n\r]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    const matchedTerms = new Set();

    // 1. Extract medical phrases first (longer matches take priority)
    medicalPhrases.forEach((phrase) => {
      if (cleanedContent.includes(phrase.toLowerCase())) {
        matchedTerms.add(phrase.toLowerCase());
        // Also add individual words from the phrase
        phrase
          .toLowerCase()
          .split(" ")
          .forEach((word) => {
            if (word.length > 2) matchedTerms.add(word);
          });
      }
    });

    // 2. Expand abbreviations and add both abbreviation and expansion
    Object.entries(medicalAbbreviations).forEach(([abbrev, expansion]) => {
      const abbrevRegex = new RegExp(`\\b${abbrev}\\b`, "gi");
      if (abbrevRegex.test(cleanedContent)) {
        matchedTerms.add(abbrev.toLowerCase());
        matchedTerms.add(expansion.toLowerCase());
        // Add individual words from expansion
        expansion
          .toLowerCase()
          .split(" ")
          .forEach((word) => {
            if (word.length > 2) matchedTerms.add(word);
          });
      }
    });

    // 3. Extract individual meaningful words
    const words = cleanedContent
      .replace(/[^a-zA-Z0-9\s]/g, " ")
      .split(/\s+/)
      .filter((word) => word.length > 2)
      .filter(
        (word) =>
          !/^(the|and|or|of|to|in|for|with|by|from|up|on|at|as|is|was|are|were|be|been|have|has|had|do|does|did|will|would|could|should|may|might|can|must|shall|a|an|this|that|these|those|but|not|all|any|can|could|each|few|more|most|other|some|such|no|nor|too|very|will)$/i.test(
            word
          )
      );

    words.forEach((word) => matchedTerms.add(word.toLowerCase()));

    return Array.from(matchedTerms);
  };

  // Function to highlight words and phrases in transcript
  const highlightWordsInTranscript = (transcript, wordsToHighlight) => {
    if (!transcript || !wordsToHighlight.length) return transcript;

    let highlightedText = transcript;

    // Sort terms by length (longest first) to prioritize phrase matches over individual words
    const sortedTerms = wordsToHighlight
      .filter((term) => term && term.length > 2)
      .sort((a, b) => b.length - a.length);

    // Simple approach: highlight each term without complex overlap detection
    sortedTerms.forEach((term) => {
      // Escape special regex characters
      const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      // Create regex for word boundaries
      const regex = new RegExp(`\\b${escapedTerm}\\b`, "gi");

      // Apply highlighting - avoid highlighting already highlighted content
      highlightedText = highlightedText.replace(regex, (match) => {
        // Don't highlight if this text is already inside a span
        return `<mark style="background-color: yellow; padding: 2px; border-radius: 3px;">${match}</mark>`;
      });
    });

    return highlightedText;
  };

  // Handle text selection in note textarea
  const handleNoteSelection = (e) => {
    const textarea = e.target;
    const selectedText = textarea.value.substring(
      textarea.selectionStart,
      textarea.selectionEnd
    );

    // Check if selected text contains any of the section headings
    const sectionHeadings = ["ASSESSMENT", "PLAN", "SUBJECTIVE", "OBJECTIVE"];
    const selectedSection = sectionHeadings.find((section) =>
      selectedText.toUpperCase().includes(section)
    );

    if (selectedSection) {
      // Extract content from the selected section
      const sectionContent = extractSectionContent(note, selectedSection);
      const wordsFromSection = extractWordsFromSection(sectionContent);

      // Update state with extracted words
      setSelectedSectionWords(wordsFromSection);

      // Generate highlighted transcript
      const highlighted = highlightWordsInTranscript(
        diarizedTranscript,
        wordsFromSection
      );
      setHighlightedTranscript(highlighted);

      console.log(`Selected section: ${selectedSection}`);
      console.log(`Extracted words:`, wordsFromSection);
    }
  };

  // Function to clear highlighting
  const clearHighlighting = () => {
    setSelectedSectionWords([]);
    setHighlightedTranscript("");
  };
  const [note, setNote] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [codingInfo, setCodingInfo] = useState("");
  const [LOSCode, setLOSCode] = useState("");
  const [encounterTime, setEncounterTime] = useState("");
  const [timeBasedCode, setTimeBasedCode] = useState("");
  const [icd_10_codes, setICD_10_codes] = useState("");
  const [orders, setOrders] = useState("");
  const [patientData, setPatientData] = useState({});
  const [selectedCodes, setSelectedCodes] = useState({});
  const [primaryCodes, setPrimaryCodes] = useState([]);
  const [secondaryCodes, setSecondaryCodes] = useState([]);

  //stores the original icd10 codes json with default and selected
  const [originalCodes, setOriginalCodes] = useState({});

  //state variable to keep track of if alternative or similar codes modal will show up.
  const [showAlternativeCodes, setShowAlternativeCodes] = useState(false);

  // Macros Logic:

  //macros state variables. initalizing with the structure of the json object to reduce number of null checks and make code cleaner.
  const [macros, setMacros] = useState({
    suggested_macros: [
      {
        dot_phrase: "",
        keyword: "",
        value: "",
      },
    ],
    accepted: [],
    added_macros: [],
  });

  //state var to handle macro hover events
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);

  // PAIN SCORE state variables
  const [painScore, setPainScore] = useState("");
  const [painScoreChecks, setPainScoreChecks] = useState({
    noaction: false,
    education: false,
    relaxation: false,
    applyHeat: false,
    applyIce: false,
    reassessPain: false,
    cognitiveBehavioralTherapy: false,
    continueCurrentPainRegimen: false,
    recommendOTC: false,
    prescribedCOX2: false,
    prescribedAnxiolytic: false,
    prescribedAntidepressant: false,
    prescribedSteroidalAntiInflammatory: false,
    prescribedOpioids: false,
    referToPainManagement: false,
    referToRadiationTherapy: false,
    referToPalliativeCare: false,
    other: false,
  });
  const [painScoreOther, setPainScoreOther] = useState("");
  const [reassessPainInterval, setReassessPainInterval] = useState("");
  const [recommendOTCDetails, setRecommendOTCDetails] = useState("");
  const [prescribedCOX2Details, setPrescribedCOX2Details] = useState("");
  const [prescribedAnxiolyticDetails, setPrescribedAnxiolyticDetails] =
    useState("");
  const [prescribedAntidepressantDetails, setPrescribedAntidepressantDetails] =
    useState("");
  const [prescribedSteroidalDetails, setPrescribedSteroidalDetails] =
    useState("");
  const [prescribedOpioidsDetails, setPrescribedOpioidsDetails] = useState("");

  // PHQ state variables
  const [phqScore, setPhqScore] = useState("");
  const [phqChecks, setPhqChecks] = useState({
    supporteducatetocallifworse: false,
    encourageaerobicactivity: false,
    behavioralactivation: false,
    Psychotherapy: false,
    refertochaplain: false,
    refertomentalhealthspecialist: false,
    refertointegrativemedicine: false,
    continuecurrentantidepressant: false,
    prescribedantidepressant: false,
    Dir_PCP: false,
    Dir_menprov: false,
    depressionplanother: false,
  });
  const [phqOther, setPhqOther] = useState("");

  // Fax Recipients state variables
  const [faxRecipients, setFaxRecipients] = useState([]);

  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const textareaRef = useRef(null);

  // Close help tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  useEffect(() => {
    setPrimaryCodes(
      selectedCodes?.codes?.filter((code) => code.codeType === "Primary") || []
    );
    setSecondaryCodes(
      selectedCodes?.codes?.filter((code) => code.codeType === "Secondary") ||
        []
    );
  }, [selectedCodes]);

  //function to check if the primary code is iron deficiency anemia, unspecified
  const isUnspecifiedAnemia = (codeName) => {
    if (
      codeName === "Iron deficiency anemia, unspecified" ||
      codeName === "Anemia, unspecified"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const saveSelectedCodes = async (newSelectedCodes) => {
    try {
      // newSelectedCodes should have the shape { codes: [...] }
      // not { default: {...}, selected_codes: {...} }
      // if your server expects just an object with "codes".
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/notes/todos/icd10/${patient.patient_id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
          body: JSON.stringify(newSelectedCodes), // => { codes: [...] }
        }
      );

      if (!response.ok) {
        // sendSlackNotification("error", {
        //   error_message: `Error saving selected codes: ${response.statusText}`,
        //   status_code: response.status,
        // });
        throw new Error(`Error saving selected codes: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Successfully saved selected codes:", data);
      //setSelectedCodes(data.selected_codes);
    } catch (error) {
      console.error("Failed to save selected codes:", error);
    }
  };

  const [diarizedTranscript, setDiarizedTranscript] = useState(
    patient.diarized_transcript
  );
  const [diarizedTranscriptCsvUrl, setDiarizedTranscriptCsvUrl] = useState(
    patient.diarized_transcript_csv_url
  );

  const [hcc_codes, setHCC_Codes] = useState(patient.hcc_codes);
  const [cpt_codes, setCPT_codes] = useState(patient.cpt_codes);

  const quillRef = useRef();

  const isLocked = patient.status === "Locked";

  const convertPlainTextToHtml = (text) => {
    // Check if text is truthy before attempting to replace
    return text ? text.replace(/\n/g, "<br>") : "";
  };
  const responseHtml = convertPlainTextToHtml(note);

  // const quillModules = {
  //   toolbar: [
  //     [{ header: [1, 2, 3, false] }],
  //     ["bold", "italic", "underline", "strike"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     [{ align: [] }],
  //     [{ color: [] }, { background: [] }],
  //     ["clean"],
  //   ],
  // };

  //useEffect to handle csv download
  useEffect(() => {
    setDiarizedTranscriptCsvUrl(patient.diarized_transcript_csv_url);
  }, [patient.diarized_transcript_csv_url]);

  const handleTranscriptDownload = () => {
    if (diarizedTranscriptCsvUrl) {
      //create anchor element
      const link = document.createElement("a");
      link.href = diarizedTranscriptCsvUrl;

      // set download attribute with csv file name
      link.download = `${diarizedTranscriptCsvUrl}`;

      // append anchor element to body
      document.body.appendChild(link);

      //trigger click event
      link.click();

      //clean up
      document.body.removeChild(link);
    }
  };

  const [codesCount, setCodesCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);

  //useEffect to handle csv download
  useEffect(() => {
    setCodesCount(icd_10_codes?.match(/([A-Z]\d+\.\d+)/g)?.length);
  }, [icd_10_codes]);

  useEffect(() => {
    setOrdersCount(orders?.match(/([t][e][s][t]_[n][a][m][e])/g)?.length);
  }, [orders]);

  // useEffect to handle automatic PHQ checkbox selection
  useEffect(() => {
    // If PHQ score is "<5 ~ Negative", automatically check the "Support - Educate to call if worse" checkbox
    if (phqScore === "<5 ~ Negative") {
      // console.log(
      //   "PHQ score is <5 ~ Negative, setting 'Support - Educate to call if worse' checkbox to true"
      // );
      setPhqChecks((prev) => ({
        ...prev,
        supporteducatetocallifworse: true,
      }));
    }
  }, [phqScore]);

  // If pain score is 0, automatically check the "Zero score no action needed" checkbox
  useEffect(() => {
    if (painScore === "0") {
      setPainScoreChecks((prev) => ({
        ...prev,
        noaction: true,
      }));
    }
  }, [painScore]);

  //delete modal state variables
  const [showDelete, setShowDelete] = useState(false);

  // Track which code we're deleting
  const [codeToDelete, setCodeToDelete] = useState(null);

  // EditPatient.jsx (snippet)
  const handleDeleteCode = (codeObject) => {
    if (!codeObject) return;
    // Remove from local state, but do NOT call saveSelectedCodes here
    const updatedCodes = selectedCodes.codes.filter(
      (c) => c.code !== codeObject.code
    );
    setSelectedCodes({ ...selectedCodes, codes: updatedCodes });
    setShowDelete(false);
  };

  //function to determine if suggested codes or alternative modals show up
  const checkSimilarOrAlternative = (code) => {
    if (code.alternatives) {
      setShowAlternativeCodes(true);
    } else if (code.similar) {
      setShowSuggestions(true);
    } else {
      setShowAlternativeCodes(false);
      setShowSuggestions(false);
    }
  };

  // Add new function to fetch complete patient data
  const fetchCompletePatientData = async (patientId, dateOfAppt) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dashboard/`,
        {
          method: "GET",
          headers: {
            token: localStorage.token,
            pickedDate: dateOfAppt,
          },
        }
      );

      const data = await response.json();
      // Find the specific patient in the response
      const completePatientData = data.find((p) => p.patient_id === patientId);
      if (completePatientData) {
        setPatientData(completePatientData);
        setDescription(completePatientData.description);
        setNote(completePatientData.note);
        setCodingInfo(completePatientData.coding_information);
        setLOSCode(completePatientData.los_code);
        setEncounterTime(completePatientData.time_spent);
        setTimeBasedCode(completePatientData.time_based_code);
        setICD_10_codes(completePatientData.icd_10_codes);
        setOrders(completePatientData.orders);
        setDiarizedTranscript(completePatientData.diarized_transcript);
        setDiarizedTranscriptCsvUrl(
          completePatientData.diarized_transcript_csv_url
        );
        setCPT_codes(completePatientData.cpt_codes);
        setHCC_Codes(completePatientData.hcc_codes);
        setSelectedCodes(formatICD10Codes(completePatientData.icd10_codes_v2));
        setOriginalCodes(completePatientData.icd10_codes_v2);
        setMdmSuggestion(completePatientData.mdm_suggested);

        //NOTE: comment back to test with real macros data from the server.
        setMacros(completePatientData.macros);
        setChartHistory(completePatientData.chart_history);
        setPatientSummary(completePatientData.patient_summary);
        // Process fax_recipients from chart_history if available
        // Check both locations: chart_history.fax_recipients and root-level FaxRecipients
        let faxRecipientsSource = null;

        if (
          completePatientData.chart_history &&
          completePatientData.chart_history.FaxRecipients
        ) {
          faxRecipientsSource = completePatientData.chart_history.FaxRecipients;
          //console.log("Found fax recipients in chart_history.FaxRecipients");
        }

        if (faxRecipientsSource) {
          const faxRecipientsData = faxRecipientsSource.map((recipient) => {
            // Find the 'all' checkbox value
            const allCheckbox = recipient.checkboxes?.find(
              (cb) => cb.column === "all"
            );
            // Find the 'summary_only' checkbox value
            const summaryOnlyCheckbox = recipient.checkboxes?.find(
              (cb) => cb.column === "summary_only"
            );

            return {
              all: allCheckbox ? allCheckbox.value : false,
              summaryOnly: summaryOnlyCheckbox
                ? summaryOnlyCheckbox.value
                : false,
              type: recipient.type || "",
              name: recipient.name || "",
              phone: recipient.phone || "",
              inactive: recipient.inactive || "",
              // Store the original checkboxes array with IDs for later submission
              originalCheckboxes: recipient.checkboxes || [],
            };
          });

          setFaxRecipients(faxRecipientsData);
        }

        // Check for pain_scale and phq_scale in chart_history and set default values
        if (completePatientData.chart_history) {
          // Handle pain_scale if available
          if (
            completePatientData.chart_history.pain_scale &&
            completePatientData.chart_history.pain_scale !== ""
          ) {
            console.log(
              "Found pain_scale in chart_history:",
              completePatientData.chart_history.pain_scale
            );
            const painScaleValue = completePatientData.chart_history.pain_scale;
            setPainScore(painScaleValue);

            // If pain scale is "0 - No Pain.", automatically check the "No pain - not applicable" checkbox
            if (
              painScaleValue === "0" ||
              painScaleValue === 0 ||
              painScaleValue === "0 - No Pain."
            ) {
              console.log(
                "Setting 'No pain - not applicable' checkbox to true"
              );
              setPainScoreChecks((prev) => ({
                ...prev,
                noaction: true,
              }));
            }
          }

          // Handle phq_scale if available
          if (
            completePatientData.chart_history.phq_scale &&
            completePatientData.chart_history.phq_scale !== ""
          ) {
            console.log(
              "Found phq_scale in chart_history:",
              completePatientData.chart_history.phq_scale
            );
            const phqScaleValue = completePatientData.chart_history.phq_scale;
            setPhqScore(phqScaleValue);

            // If PHQ scale is "<5 ~ Negative", automatically check the "Support - Educate to call if worse" checkbox
            if (phqScaleValue === "<5 ~ Negative") {
              console.log(
                "Setting 'Support - Educate to call if worse' checkbox to true"
              );
              setPhqChecks((prev) => ({
                ...prev,
                supportEducate: true,
              }));
            }
          }
        }
      }
    } catch (err) {
      console.error("Error fetching complete patient data:", err.message);
    }
  };

  // Guard: do not render if no valid patient
  if (!patient || !patient.patient_id) {
    return null;
  }

  return (
    <Fragment>
      <div
        role="edit-patient"
        className="flex items-center hover:text-secondary-text-grey"
      >
        <div className="pr-2">
          <svg
            className="w-6 h-6 text-background1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 4h3c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1H6a1 1 0 01-1-1V5c0-.6.4-1 1-1h3m0 3h6m-6 7l2 2 4-4m-5-9v4h4V3h-4z"
            />
          </svg>
        </div>

        {/* Here we show "Review" or "Locked" plus (Added) sub-status if uploading or uploaded */}
        <button
          type="button"
          className={`text-xl ${
            status === "Review" ? "" : "flex items-center text-ktx-red"
          }`}
          data-bs-toggle="modal"
          data-bs-target={`#id${patient.patient_id}`}
          onClick={async () => {
            await fetchCompletePatientData(
              patient.patient_id,
              patient.date_of_appt
            );
            log_review_note(patient.patient_id);
            setIsEditing(status !== "Locked");
          }}
        >
          {status === "Review" ? (
            "Review"
          ) : (
            <div>
              Locked (View Only)
              {ehrUploadStatus === "uploading" && (
                <div className="text-white text-sm">Uploading to EHR...</div>
              )}
              {ehrUploadStatus === "success" && (
                <div className="text-white text-sm">Uploaded to EHR</div>
              )}
            </div>
          )}
        </button>
      </div>

      <div
        className="modal fade modal-xl h-full"
        id={`id${patient.patient_id}`}
        tabIndex="-1"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        role="edit-modal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1
                className="text-accent1 text-3xl font-bold"
                id="editModalLabel"
              >
                Review {patient.description}'s Note
              </h1>
              <button
                type="button"
                className="mt-0 mb-3"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setDescription(patient.description);
                  setNote(patient.note);
                  setCodingInfo(patient.coding_information);
                  setLOSCode(patient.los_code);
                  log_review_note(patient.patient_id);
                  setEncounterTime(patient.time_spent);
                  setTimeBasedCode(patient.time_based_code);
                  setICD_10_codes(patient.icd_10_codes);
                  setOrders(patient.orders);
                  setPatientData(patientData);
                  setIsCopied(false);
                  // set isEditing back to false on close button
                  setIsEditing(false);
                  setDiarizedTranscript(patient.diarized_transcript);
                  setDiarizedTranscriptCsvUrl(
                    patient.diarized_transcript_csv_url
                  );
                  setCPT_codes(patient.cpt_codes);
                  setHCC_Codes(patient.hcc_codes);
                  setSelectedCodes(selectedCodes);
                }}
              >
                <svg
                  className="w-6 h-6 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18 17.94 6M18 18 6.06 6"
                  />
                </svg>
              </button>
            </div>
            <div className="modal-body ">
              <div>
                <nav>
                  <div
                    className="text-black flex mb-0 whitespace-nowrap overflow-x-auto "
                    id={`id${patient.patient_id}nav-tab`}
                    role="tablist"
                  >
                    <button
                      className=" nav-link active border-light-grey pt-2 pl-11 pr-11 pb-2 mr-4  bg-secondary-grey rounded-t-md focus:bg-accent1 focus:text-background1 text-accent1 font-bold"
                      id={`id${patient.patient_id}nav-home-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#id${patient.patient_id}nav-home`}
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      Note
                    </button>

                    <button
                      className="nav-link border pt-2 pl-11 pr-11 pb-2 mr-4 rounded-t-md focus:bg-accent1 focus:text-background1 text-accent1  bg-secondary-grey font-bold"
                      id={`id${patient.patient_id}nav-orders-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#id${patient.patient_id}nav-orders`}
                      type="button"
                      role="tab"
                      aria-controls="nav-orders"
                      aria-selected="false"
                      onClick={() => {
                        sendServerLogging({
                          body: {
                            ...userJSON(localStorage.getItem("userName")),
                            event: "ORDERS_TAB_CLICKED",
                            eventData: { mrn: patient.mrn },
                            patientId: patient.patient_id,
                          },
                        });
                      }}
                    >
                      Orders ({ordersCount ? ordersCount : 0})
                    </button>
                    {/* TODO: remove the cCare conditional, just having it here so it renders. */}

                    <button
                      className="nav-link border pt-2 pl-11 pr-11 pb-2 mr-4 rounded-t-md focus:bg-accent1 focus:text-background1 text-accent1  bg-secondary-grey font-bold"
                      id={`id${patient.patient_id}nav-diarized-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#id${patient.patient_id}nav-diarized`}
                      type="button"
                      role="tab"
                      aria-controls="nav-diarized"
                      aria-selected="false"
                      onClick={() => {
                        sendServerLogging({
                          body: {
                            ...userJSON(localStorage.getItem("userName")),
                            event: "TRANSCRIPT_TAB_CLICK",
                            eventData: { mrn: patient.mrn },
                            patiendId: patient.patientId,
                          },
                        });
                      }}
                    >
                      Transcript
                    </button>
                    {/* show patient summary tab only to VA users */}
                    {showPatientSummary && (
                      <button
                        className="nav-link border pt-2 pl-11 pr-11 pb-2 mr-4 rounded-t-md focus:bg-accent1 focus:text-background1 text-accent1  bg-secondary-grey font-bold"
                        id={`id${patient.patient_id}nav-summary-tab`}
                        data-bs-toggle="tab"
                        data-bs-target={`#id${patient.patient_id}nav-summary`}
                        type="button"
                        role="tab"
                        aria-controls="nav-summary"
                        aria-selected="false"
                        onClick={() => {
                          sendServerLogging({
                            body: {
                              ...userJSON(localStorage.getItem("userName")),
                              event: "PATIENT_VISIT_SUMMARY_TAB_CLICK",
                              eventData: { mrn: patient.mrn },
                              patientId: patient.patient_id,
                            },
                          });
                        }}
                      >
                        Patient Visit Summary
                      </button>
                    )}
                  </div>
                </nav>
                <div
                  className="tab-content p-4 border-t-2 border-t-accent1 border-x-2  border-x-transparent-grey"
                  id="nav-tabContent"
                >
                  <div
                    className="tab-pane fade show active"
                    id={`id${patient.patient_id}nav-home`}
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="float-end d-flex mt-3 mb-3">
                      <CopyToClipboard
                        // text={responseHtml || ""}
                        // options={{ format: "text/html" }}
                        text={note}
                        onCopy={() => onCopy(patient.patient_id)}
                      >
                        {isCopied ? (
                          <div className="text-success text-sm">✓ Copied!</div>
                        ) : (
                          <div className="flex ">
                            <img
                              src={clipboard}
                              width="20"
                              height="20"
                              alt="copy"
                              className="mr-1 hover:cursor-pointer"
                            />
                            <h1 className="text-accent1 hover:cursor-pointer">
                              Copy Note
                            </h1>
                          </div>
                        )}
                      </CopyToClipboard>
                    </div>
                    <div className="mt-5">
                      <textarea
                        type="text"
                        readOnly={status === "Locked"} // Apply readOnly based on status
                        className="form-control resize-none rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey"
                        value={note || ""}
                        onChange={(e) => {
                          setNote(e.target.value);
                          setIsCopied(false);
                          nextAction("note-textarea");
                          setCursorPosition(e.target.selectionStart);
                        }}
                        onClick={(e) => {
                          setCursorPosition(e.target.selectionStart);

                          sendServerLogging({
                            body: {
                              ...userJSON(localStorage.getItem("userName")),
                              event: "EDIT_NOTE_TEXT_AREA",
                              eventData: { mrn: patient.mrn },
                              patientId: patient.patient_id,
                            },
                          });
                        }}
                        onMouseUp={handleNoteSelection}
                        rows="30"
                      ></textarea>

                      {/* Macros section */}

                      <div className="flex flex-col mt-3">
                        <div className="relative inline-block" ref={tooltipRef}>
                          <div className="flex items-center mb-4 gap-2">
                            <h2 className="text-xl font-semibold text-knowtex-grey">
                              Macros:
                            </h2>

                            <p className="text-sm italic text-light-grey">
                              Click where you'd like to insert a macro, then
                              make your selection below.
                            </p>
                          </div>
                        </div>

                        <div>
                          <MacrosFeature
                            macros={macros}
                            setMacros={setMacros}
                            setNote={setNote}
                            cursorPosition={cursorPosition}
                            setCursorPosition={setCursorPosition}
                            textareaRef={textareaRef}
                            name={name}
                            status={status}
                            patient={patient}
                          />
                        </div>
                      </div>

                      {/* PAIN SCORE and PHQ sections - Only show for Ironwood */}
                      {superOrg && superOrg.includes("Ironwood") && (
                        <div className="flex flex-row space-x-4 mt-3">
                          {/* PAIN SCORE Section */}
                          <div className="flex flex-col w-1/2">
                            <div className="flex items-center mb-4 gap-2">
                              <h2 className="text-lg font-semibold text-knowtex-grey">
                                PAIN SCORE:
                              </h2>
                              <select
                                className="form-select rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey"
                                value={painScore}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  setPainScore(selectedValue);

                                  // If pain score of 0 is selected, automatically check "No pain - not applicable"
                                  if (selectedValue.startsWith("0")) {
                                    setPainScoreChecks((prev) => ({
                                      ...prev,
                                      noaction: true,
                                    }));
                                  }
                                }}
                                disabled={status === "Locked"}
                              >
                                <option value="">Select score</option>
                                <option value="0 - No Pain.">
                                  0 - No Pain.
                                </option>
                                <option value="1 - Very Mild.">
                                  1 - Very Mild.
                                </option>
                                <option value="2 - Discomforting.">
                                  2 - Discomforting.
                                </option>
                                <option value="3 - Tolerating">
                                  3 - Tolerating
                                </option>
                                <option value="4 - Distressing.">
                                  4 - Distressing.
                                </option>
                                <option value="5 - Very distressing.">
                                  5 - Very distressing.
                                </option>
                                <option value="6 - Intense pain.">
                                  6 - Intense pain.
                                </option>
                                <option value="7 - Very intense pain.">
                                  7 - Very intense pain.
                                </option>
                                <option value="8 - Horrible pain.">
                                  8 - Horrible pain.
                                </option>
                                <option value="9 - Excruciating.">
                                  9 - Excruciating.
                                </option>
                                <option value="10 - Unimaginable pain.">
                                  10 - Unimaginable pain.
                                </option>
                              </select>
                            </div>
                            <div className="grid grid-cols-2 gap-1">
                              {Object.entries(painScoreChecks).map(
                                ([key, value]) => (
                                  <div key={key} className="flex items-center">
                                    <input
                                      type="checkbox"
                                      id={`pain-${key}`}
                                      checked={value}
                                      onChange={() => {
                                        setPainScoreChecks({
                                          ...painScoreChecks,
                                          [key]: !value,
                                        });

                                        // If reassessPain is checked, show the interval input
                                        if (key === "reassessPain") {
                                          setReassessPainInterval(
                                            !value ? "" : reassessPainInterval
                                          );
                                        }
                                      }}
                                      className="mr-2"
                                      disabled={status === "Locked"}
                                    />
                                    <label
                                      htmlFor={`pain-${key}`}
                                      className="text-accent1 text-sm"
                                    >
                                      {key === "noaction"
                                        ? "No pain - not applicable"
                                        : key === "education"
                                        ? "Education"
                                        : key === "relaxation"
                                        ? "Relaxation"
                                        : key === "applyHeat"
                                        ? "Apply Heat"
                                        : key === "applyIce"
                                        ? "Apply Ice"
                                        : key === "reassessPain"
                                        ? "Reassess pain at (interval)"
                                        : key === "cognitiveBehavioralTherapy"
                                        ? "Cognitive-behavioral therapy"
                                        : key === "continueCurrentPainRegimen"
                                        ? "Continue current pain regimen"
                                        : key === "recommendOTC"
                                        ? "Recommend OTC medication"
                                        : key === "prescribedCOX2"
                                        ? "Prescribed COX-2 inhibitor"
                                        : key === "prescribedAnxiolytic"
                                        ? "Prescribed anxiolytic"
                                        : key === "prescribedAntidepressant"
                                        ? "Prescribed antidepressant"
                                        : key ===
                                          "prescribedSteroidalAntiInflammatory"
                                        ? "Prescribed steriodal anti-inflammatory"
                                        : key === "prescribedOpioids"
                                        ? "Prescribed opioids"
                                        : key === "referToPainManagement"
                                        ? "Refer to pain management"
                                        : key === "referToRadiationTherapy"
                                        ? "Refer to radiation therapy for local XRT"
                                        : key === "referToPalliativeCare"
                                        ? "Refer to palliative care specialist"
                                        : "Other"}
                                    </label>
                                  </div>
                                )
                              )}
                            </div>

                            {/* Conditional inputs for Pain Score */}
                            {painScoreChecks.reassessPain && (
                              <div className="mt-2">
                                <label
                                  htmlFor="reassess-interval"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Reassess interval:
                                </label>
                                <input
                                  type="text"
                                  id="reassess-interval"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={reassessPainInterval}
                                  onChange={(e) =>
                                    setReassessPainInterval(e.target.value)
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter interval"
                                />
                              </div>
                            )}

                            {painScoreChecks.recommendOTC && (
                              <div className="mt-2">
                                <label
                                  htmlFor="recommend-otc-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  OTC medication details:
                                </label>
                                <input
                                  type="text"
                                  id="recommend-otc-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={recommendOTCDetails}
                                  onChange={(e) =>
                                    setRecommendOTCDetails(e.target.value)
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.prescribedCOX2 && (
                              <div className="mt-2">
                                <label
                                  htmlFor="prescribed-cox2-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  COX-2 inhibitor details:
                                </label>
                                <input
                                  type="text"
                                  id="prescribed-cox2-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={prescribedCOX2Details}
                                  onChange={(e) =>
                                    setPrescribedCOX2Details(e.target.value)
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.prescribedAnxiolytic && (
                              <div className="mt-2">
                                <label
                                  htmlFor="prescribed-anxiolytic-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Anxiolytic details:
                                </label>
                                <input
                                  type="text"
                                  id="prescribed-anxiolytic-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={prescribedAnxiolyticDetails}
                                  onChange={(e) =>
                                    setPrescribedAnxiolyticDetails(
                                      e.target.value
                                    )
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.prescribedAntidepressant && (
                              <div className="mt-2">
                                <label
                                  htmlFor="prescribed-antidepressant-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Antidepressant details:
                                </label>
                                <input
                                  type="text"
                                  id="prescribed-antidepressant-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={prescribedAntidepressantDetails}
                                  onChange={(e) =>
                                    setPrescribedAntidepressantDetails(
                                      e.target.value
                                    )
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.prescribedSteroidalAntiInflammatory && (
                              <div className="mt-2">
                                <label
                                  htmlFor="prescribed-steroidal-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Steroidal anti-inflammatory details:
                                </label>
                                <input
                                  type="text"
                                  id="prescribed-steroidal-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={prescribedSteroidalDetails}
                                  onChange={(e) =>
                                    setPrescribedSteroidalDetails(
                                      e.target.value
                                    )
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.prescribedOpioids && (
                              <div className="mt-2">
                                <label
                                  htmlFor="prescribed-opioids-details"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Opioids details:
                                </label>
                                <input
                                  type="text"
                                  id="prescribed-opioids-details"
                                  className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                  value={prescribedOpioidsDetails}
                                  onChange={(e) =>
                                    setPrescribedOpioidsDetails(e.target.value)
                                  }
                                  disabled={status === "Locked"}
                                  placeholder="Enter medication details"
                                />
                              </div>
                            )}

                            {painScoreChecks.other && (
                              <div className="mt-2">
                                <label
                                  htmlFor="pain-other"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Other:
                                </label>
                                <div className="flex gap-2">
                                  <input
                                    type="text"
                                    id="pain-other"
                                    className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                    value={painScoreOther}
                                    onChange={(e) =>
                                      setPainScoreOther(e.target.value)
                                    }
                                    disabled={status === "Locked"}
                                    placeholder="Specify other pain management"
                                  />
                                </div>
                              </div>
                            )}
                          </div>

                          {/* PHQ Section */}
                          <div className="flex flex-col w-1/2">
                            <div className="flex items-center mb-4 gap-2">
                              <h2 className="text-lg font-semibold text-knowtex-grey">
                                PHQ:
                              </h2>
                              <select
                                className="form-select rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey"
                                value={phqScore}
                                onChange={(e) => setPhqScore(e.target.value)}
                                disabled={status === "Locked"}
                              >
                                <option value="">Select score</option>
                                <option value="<5 ~ Negative">
                                  &lt;5 ~ Negative
                                </option>
                                <option value="5-9 ~ Minimal Symptoms">
                                  5-9 ~ Minimal Symptoms
                                </option>
                                <option value="10-14 ~ Minor Depression">
                                  10-14 ~ Minor Depression
                                </option>
                                <option value="15-19 ~ Major Depression, moderately severe">
                                  15-19 ~ Major Depression, moderately severe
                                </option>
                                <option value="20+ ~ Major Depression, severe">
                                  20+ ~ Major Depression, severe
                                </option>
                              </select>
                            </div>
                            <div className="grid grid-cols-2 gap-1">
                              {Object.entries(phqChecks).map(([key, value]) => (
                                <div key={key} className="flex items-center">
                                  <input
                                    type="checkbox"
                                    id={`phq-${key}`}
                                    checked={value}
                                    onChange={() => {
                                      setPhqChecks({
                                        ...phqChecks,
                                        [key]: !value,
                                      });
                                    }}
                                    className="mr-2"
                                    disabled={status === "Locked"}
                                  />
                                  <label
                                    htmlFor={`phq-${key}`}
                                    className="text-accent1 text-sm"
                                  >
                                    {key === "supporteducatetocallifworse"
                                      ? "Support - Educate to call if worse"
                                      : key === "encourageaerobicactivity"
                                      ? "Encourage Aerobic Activity"
                                      : key === "behavioralactivation"
                                      ? "Behavioral Activation"
                                      : key === "Psychotherapy"
                                      ? "Refer to Social Work"
                                      : key === "refertochaplain"
                                      ? "Refer to Chaplaincy Care"
                                      : key === "refertomentalhealthspecialist"
                                      ? "Refer to Mental Health Specialist"
                                      : key === "refertointegrativemedicine"
                                      ? "Refer to integrative medicine"
                                      : key === "continuecurrentantidepressant"
                                      ? "Continue Current Antidepressant"
                                      : key === "prescribedantidepressant"
                                      ? "Prescribed Antidepressant"
                                      : key === "Dir_PCP"
                                      ? "Directed patient to discuss with PCP"
                                      : key === "Dir_menprov"
                                      ? "Directed patient to discuss with established mental health provider"
                                      : key === "depressionplanother"
                                      ? "Other:"
                                      : "Other"}
                                  </label>
                                </div>
                              ))}
                            </div>

                            {/* Conditional input for PHQ Other */}
                            {phqChecks.depressionplanother && (
                              <div className="mt-2">
                                <label
                                  htmlFor="phq-other"
                                  className="text-accent1 text-sm block mb-1"
                                >
                                  Other:
                                </label>
                                <div className="flex gap-2">
                                  <input
                                    type="text"
                                    id="phq-other"
                                    className="form-control rounded-md border-0 shadow-knowtex-shadow text-accent1 bg-secondary-grey w-full"
                                    value={phqOther}
                                    onChange={(e) =>
                                      setPhqOther(e.target.value)
                                    }
                                    disabled={status === "Locked"}
                                    placeholder="Specify other PHQ action"
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {superOrg && superOrg === "Ironwood" && (
                        <>
                          {/* Fax Recipients Section */}
                          <div className="flex flex-col mt-3">
                            <div className="flex items-center gap-2">
                              <h1 className="text-accent1 text-xl font-medium mb-2">
                                Fax Recipients
                              </h1>
                            </div>
                            <div className="mb-4 overflow-x-auto">
                              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                                <thead>
                                  <tr className="bg-gray-100 border-b border-gray-200">
                                    <th className="py-2 px-4 text-left w-16 text-black font-medium">
                                      All
                                    </th>
                                    <th className="py-2 px-4 text-left w-28 text-black font-medium">
                                      Summary Only
                                    </th>
                                    <th className="py-2 px-4 text-left text-black font-medium">
                                      Type
                                    </th>
                                    <th className="py-2 px-4 text-left text-black font-medium">
                                      Name
                                    </th>
                                    <th className="py-2 px-4 text-left text-black font-medium">
                                      Fax Number
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {faxRecipients.map((recipient, index) => (
                                    <tr
                                      key={index}
                                      className="border-b border-gray-200 hover:bg-gray-50"
                                    >
                                      <td className="py-2 px-4">
                                        <input
                                          type="checkbox"
                                          checked={recipient.all}
                                          onChange={() => {
                                            const updatedRecipients = [
                                              ...faxRecipients,
                                            ];
                                            const newAllValue =
                                              !updatedRecipients[index].all;

                                            // Update the UI state
                                            updatedRecipients[index] = {
                                              ...updatedRecipients[index],
                                              all: newAllValue,
                                              // If 'all' is being unchecked, also uncheck 'summaryOnly'
                                              summaryOnly: newAllValue
                                                ? updatedRecipients[index]
                                                    .summaryOnly
                                                : false,
                                            };

                                            // Update the original checkboxes for submission
                                            if (
                                              updatedRecipients[index]
                                                .originalCheckboxes
                                            ) {
                                              const allCheckboxIndex =
                                                updatedRecipients[
                                                  index
                                                ].originalCheckboxes.findIndex(
                                                  (cb) => cb.column === "all"
                                                );
                                              if (allCheckboxIndex !== -1) {
                                                updatedRecipients[
                                                  index
                                                ].originalCheckboxes[
                                                  allCheckboxIndex
                                                ].value = newAllValue;
                                              }

                                              // If 'all' is being unchecked, also uncheck 'summary_only' in original checkboxes
                                              if (!newAllValue) {
                                                const summaryOnlyCheckboxIndex =
                                                  updatedRecipients[
                                                    index
                                                  ].originalCheckboxes.findIndex(
                                                    (cb) =>
                                                      cb.column ===
                                                      "summary_only"
                                                  );
                                                if (
                                                  summaryOnlyCheckboxIndex !==
                                                  -1
                                                ) {
                                                  updatedRecipients[
                                                    index
                                                  ].originalCheckboxes[
                                                    summaryOnlyCheckboxIndex
                                                  ].value = false;
                                                }
                                              }
                                            }

                                            setFaxRecipients(updatedRecipients);
                                          }}
                                          disabled={status === "Locked"}
                                          className="form-checkbox h-4 w-4 text-knowtex-blue rounded"
                                        />
                                      </td>
                                      <td className="py-2 px-4">
                                        <input
                                          type="checkbox"
                                          checked={recipient.summaryOnly}
                                          onChange={() => {
                                            // Only allow changes if 'all' is checked
                                            if (recipient.all) {
                                              const updatedRecipients = [
                                                ...faxRecipients,
                                              ];
                                              const newSummaryOnlyValue =
                                                !updatedRecipients[index]
                                                  .summaryOnly;

                                              // Update the UI state
                                              updatedRecipients[index] = {
                                                ...updatedRecipients[index],
                                                summaryOnly:
                                                  newSummaryOnlyValue,
                                              };

                                              // Update the original checkboxes for submission
                                              if (
                                                updatedRecipients[index]
                                                  .originalCheckboxes
                                              ) {
                                                const summaryOnlyCheckboxIndex =
                                                  updatedRecipients[
                                                    index
                                                  ].originalCheckboxes.findIndex(
                                                    (cb) =>
                                                      cb.column ===
                                                      "summary_only"
                                                  );
                                                if (
                                                  summaryOnlyCheckboxIndex !==
                                                  -1
                                                ) {
                                                  updatedRecipients[
                                                    index
                                                  ].originalCheckboxes[
                                                    summaryOnlyCheckboxIndex
                                                  ].value = newSummaryOnlyValue;
                                                }
                                              }

                                              setFaxRecipients(
                                                updatedRecipients
                                              );
                                            }
                                          }}
                                          disabled={
                                            status === "Locked" ||
                                            !recipient.all
                                          }
                                          className={`form-checkbox h-4 w-4 rounded ${
                                            recipient.all
                                              ? "text-knowtex-blue"
                                              : "text-gray-300 cursor-not-allowed"
                                          }`}
                                        />
                                      </td>
                                      <td className="py-2 px-4">
                                        <span className="text-black text-sm">
                                          {recipient.type}
                                        </span>
                                      </td>
                                      <td className="py-2 px-4">
                                        <span className="text-black text-sm">
                                          {recipient.name}
                                        </span>
                                      </td>
                                      <td className="py-2 px-4">
                                        <span className="text-black text-sm">
                                          {recipient.phone || ""}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div className="mt-3">
                                <button
                                  className="bg-knowtex-blue text-white px-3 py-1 rounded text-sm hover:bg-blue-600 disabled:opacity-50"
                                  onClick={() => {
                                    setFaxRecipients([
                                      ...faxRecipients,
                                      {
                                        all: false,
                                        summaryOnly: false,
                                        type: "",
                                        name: "",
                                        phone: "",
                                      },
                                    ]);
                                  }}
                                  disabled={status === "Locked"}
                                >
                                  Add Recipient
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {/* New ICD 10 Codes Section */}
                      {superOrg !== "Astera" && (
                        <div className="flex flex-col mt-3">
                          <div className="flex items-center gap-2">
                            <h1 className="text-accent1 text-xl font-medium mb-2">
                              ICD-10 Codes
                            </h1>
                            {historicalCodes.length > 0 && (
                              <span className="text-gray-500 text-sm">
                                Historic codes from the EMR have been filtered
                                out from this list.
                              </span>
                            )}
                          </div>
                          <div className="flex flex-row space-x-60">
                            {/* Primary Codes */}
                            <div className="flex flex-col items-start">
                              <div className="flex flex-row items-start">
                                <h2 className=" text-accent1 text-lg font-bold mb-2 mr-4">
                                  Primary Codes
                                </h2>
                                <div
                                  id="add-icd10-code-button"
                                  className="flex flex-row items-center cursor-pointer"
                                  onClick={() => {
                                    setShowAddCode(true);
                                    setIsPrimaryCode(true);
                                    setIsSecondaryCode(false);
                                    modifying_codes_click(patient.patient_id);
                                  }}
                                >
                                  <svg
                                    className="w-6 h-6 text-ktx-green"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4.243a1 1 0 1 0-2 0V11H7.757a1 1 0 1 0 0 2H11v3.243a1 1 0 1 0 2 0V13h3.243a1 1 0 1 0 0-2H13V7.757Z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  <span className="text-accent1 text-sm ml-1">
                                    Add Code
                                  </span>
                                </div>
                              </div>
                              {/* Render Primary Codes */}
                              {primaryCodes.map((code, index) => (
                                <div
                                  className="flex flex-row items-center space-x-2"
                                  key={code.code}
                                >
                                  <button
                                    type="button"
                                    className={`${
                                      isUnspecifiedAnemia(code.name)
                                        ? "bg-transparent-red text-ktx-red  hover:bg-ktx-red hover:text-white"
                                        : "bg-transparent-purple disabled:hover:cursor-not-allowed "
                                    } text-accent1 rounded-2xl font-bold text-lg w-fit text-left p-3 mb-3 disabled:hover:cursor-not-allowed`}
                                    onClick={() => {
                                      setCurrentSelectedCode(code);
                                      code_click(patient.patient_id);
                                      isUnspecifiedAnemia(code.name)
                                        ? setShowAlternativeCodes(true)
                                        : checkSimilarOrAlternative(code);
                                      modifying_codes_click(patient.patient_id);
                                    }}
                                  >
                                    {index + 1}. {code.code} - {code.name}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setCodeToDelete(code);
                                      console.log(code);
                                      setShowDelete(true);
                                    }}
                                  >
                                    <svg
                                      className="w-6 h-6 text-transparent-red hover:text-ktx-red cursor-pointer mb-3"
                                      aria-hidden="true"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                      />
                                    </svg>
                                  </button>
                                  {showAlternativeCodes && (
                                    <AlternativeCodeModal
                                      code={currentSelectedCode}
                                      setShowAlternativeCodes={
                                        setShowAlternativeCodes
                                      }
                                      isUnspecifiedAnemia={isUnspecifiedAnemia}
                                      selectedCodes={selectedCodes}
                                      setSelectedCodes={setSelectedCodes}
                                      setCodesChange={setCodesChange}
                                      patientID={patient.patient_id}
                                    />
                                  )}
                                </div>
                              ))}
                            </div>

                            {/* Secondary Codes */}
                            <div className="flex flex-col">
                              <div className="flex flex-row items-start">
                                <h2 className=" text-accent1 text-lg font-bold mb-2 mr-4">
                                  Secondary Codes
                                </h2>
                                <div
                                  className="flex flex-row items-center cursor-pointer"
                                  onClick={() => {
                                    modifying_codes_click(patient.patient_id);
                                    setShowAddCode(true);
                                    setIsSecondaryCode(true);
                                    setIsPrimaryCode(false);
                                  }}
                                >
                                  <svg
                                    className="w-6 h-6 text-ktx-green"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4.243a1 1 0 1 0-2 0V11H7.757a1 1 0 1 0 0 2H11v3.243a1 1 0 1 0 2 0V13h3.243a1 1 0 1 0 0-2H13V7.757Z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  <span className="text-accent1 text-sm ml-1">
                                    Add Code
                                  </span>
                                </div>
                              </div>

                              <div className="flex flex-col">
                                {/* Render Secondary Codes */}
                                {secondaryCodes.map((code, index) => (
                                  <div
                                    className="flex flex-row items-center space-x-2"
                                    key={code.code}
                                  >
                                    <button
                                      type="button"
                                      className={`${
                                        isUnspecifiedAnemia(code.name)
                                          ? "bg-transparent-red text-ktx-red  hover:bg-ktx-red hover:text-white"
                                          : "bg-transparent-purple "
                                      } text-accent1 rounded-2xl font-bold text-lg w-fit text-left p-3 mb-3  `}
                                      onClick={() => {
                                        isUnspecifiedAnemia(code.name)
                                          ? setShowAlternativeCodes(true)
                                          : checkSimilarOrAlternative(code);
                                        setCurrentSelectedCode(code);
                                        code_click(patient.patient_id);
                                        modifying_codes_click(
                                          patient.patient_id
                                        );
                                      }}
                                    >
                                      {index + 1}. {code.code} - {code.name}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setCodeToDelete(code);
                                        console.log(code);
                                        setShowDelete(true);
                                      }}
                                    >
                                      <svg
                                        className="w-6 h-6 text-transparent-red hover:text-ktx-red cursor-pointer mb-3"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                    </button>
                                    {showSuggestions && (
                                      <CodeSuggestionsModal
                                        setShowSuggestions={setShowSuggestions}
                                        selectedCode={currentSelectedCode}
                                        selectedCodes={selectedCodes}
                                        setSelectedCodes={setSelectedCodes}
                                        setCodesChange={setCodesChange}
                                        patientID={patient.patient_id}
                                      />
                                    )}
                                  </div>
                                ))}

                                {showAddCode && (
                                  <AddCodeModal
                                    showAddCode={showAddCode}
                                    setShowAddCode={setShowAddCode}
                                    setCodesChange={setCodesChange}
                                    selectedCodes={selectedCodes} // If you want to append
                                    setSelectedCodes={setSelectedCodes}
                                    setIsPrimaryCode={setIsPrimaryCode}
                                    setIsSecondaryCode={setIsSecondaryCode}
                                    isPrimaryCode={isPrimaryCode}
                                    isSecondaryCode={isSecondaryCode}
                                  />
                                )}

                                {showDelete && (
                                  <DeleteCodeModal
                                    setShowDelete={setShowDelete}
                                    codeToDelete={codeToDelete}
                                    handleDeleteCode={handleDeleteCode}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {!isCurrentCustomer.includes(superOrg) ||
                      superOrg === "Knowtex" ||
                      ["Dr. Ronnen", "Dr. Licitra", "Dr. Fang"].includes(
                        name
                      ) ? (
                        mdm_suggested ? (
                          <EMSection
                            setIsRationaleProvided={setIsRationaleProvided}
                            isRationaleProvided={isRationaleProvided}
                            mdm_selected={mdm_selected}
                            setRecommendedLevel={setRecommendedLevel}
                            setMDMSelected={setMDMSelected}
                            mdm_suggested={mdm_suggested}
                            setUserRationale={setUserRationale}
                            showRationale={showRationale}
                            setShowRationale={setShowRationale}
                            userRationale={userRationale}
                            setFinalSelectedLevel={setFinalSelectedLevel}
                            patient={patient}
                            setFinalSelectedTs={setFinalSelectedTs}
                            setMDMSelectedTs={setMDMSelectedTs}
                            encounterTime={encounterTime}
                            setEncounterTime={setEncounterTime}
                            status={status}
                          />
                        ) : null
                      ) : null}

                      {/* <ReactQuill
                        theme="snow"
                        value={responseHtml || ""}
                        onChange={(newNote) => {
                          setNote(newNote);
                          setIsCopied(false);
                        }}
                        className="text-accent1 "
                        modules={quillModules}
                        ref={quillRef}
                        formats={[
                          "header",
                          "bold",
                          "italic",
                          "underline",
                          "strike",
                          "list",
                          "bullet",
                          "align",
                          "color",
                          "background",
                        ]}
                        readOnly={isLocked}
                      /> */}
                      {/* {name === "Dr. Ketonis" ? (
                        <KetonisRTE />
                      ) : (
                        <ReactQuill
                          theme="snow"
                          value={responseHtml || ""}
                          onChange={(newNote) => {
                            setNote(newNote);
                            setIsCopied(false);
                          }}
                          className="text-accent1 "
                          modules={quillModules}
                          ref={quillRef}
                          formats={[
                            "header",
                            "bold",
                            "italic",
                            "underline",
                            "strike",
                            "list",
                            "bullet",
                            "align",
                            "color",
                            "background",
                          ]}
                        />
                      )} */}
                    </div>
                  </div>

                  <div
                    className="tab-pane fade text-accent1 text-xl font-bold"
                    id={`id${patient.patient_id}nav-orders`}
                    role="tabpanel"
                    aria-labelledby="nav-orders-tab"
                  >
                    <div className="flex flex-col">
                      <div className="flex items-center gap-2 mb-4">
                        <h1 className="text-accent1 text-xl font-medium">
                          Orders
                        </h1>
                      </div>

                      {/* Orders Table */}
                      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                        {parseOrdersFromString(orders || "").length === 0 ? (
                          <div className="p-8 text-center text-gray-500">
                            <svg
                              className="w-12 h-12 mx-auto mb-4 text-gray-300"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                            <p className="text-lg font-medium mb-2">
                              No orders yet
                            </p>
                          </div>
                        ) : (
                          <>
                            <div className="bg-gray-50 px-6 py-3 border-b border-gray-200">
                              <div className="grid grid-cols-12 gap-4 text-sm font-medium text-gray-700">
                                <div className="col-span-6">Test Name</div>
                                <div className="col-span-4">Date</div>
                                <div className="col-span-2 text-center">
                                  Actions
                                </div>
                              </div>
                            </div>
                            <div className="divide-y divide-gray-200">
                              {parseOrdersFromString(orders || "").map(
                                (order, index) => (
                                  <div
                                    key={order.id || index}
                                    className="px-6 py-4"
                                  >
                                    <div className="grid grid-cols-12 gap-4 items-center">
                                      <div className="col-span-6">
                                        <input
                                          type="text"
                                          value={order.test_name || ""}
                                          onChange={(e) => {
                                            const currentOrders =
                                              parseOrdersFromString(
                                                orders || ""
                                              );
                                            currentOrders[index].test_name =
                                              e.target.value;
                                            setOrders(
                                              formatOrdersToString(
                                                currentOrders
                                              )
                                            );
                                          }}
                                          placeholder="Enter test name"
                                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ktx-green focus:border-transparent text-gray-900 font-medium"
                                          readOnly={status === "Locked"}
                                        />
                                      </div>
                                      <div className="col-span-4">
                                        <input
                                          type="date"
                                          value={(() => {
                                            const dateValue =
                                              order.estimated_test_due_date ||
                                              order.test_due_duration ||
                                              "";
                                            // Convert common text values to date format
                                            if (
                                              dateValue.toLowerCase() ===
                                              "today"
                                            ) {
                                              return new Date()
                                                .toISOString()
                                                .split("T")[0];
                                            }
                                            // If it's already a valid date format, use it
                                            if (
                                              dateValue.match(
                                                /^\d{4}-\d{2}-\d{2}$/
                                              )
                                            ) {
                                              return dateValue;
                                            }
                                            // Try to parse other date formats
                                            const parsedDate = new Date(
                                              dateValue
                                            );
                                            if (
                                              !isNaN(parsedDate.getTime()) &&
                                              dateValue
                                            ) {
                                              return parsedDate
                                                .toISOString()
                                                .split("T")[0];
                                            }
                                            return "";
                                          })()}
                                          onChange={(e) => {
                                            const currentOrders =
                                              parseOrdersFromString(
                                                orders || ""
                                              );
                                            const selectedDate = e.target.value;

                                            // Convert date to a more readable format if needed
                                            let dateToStore = selectedDate;
                                            if (selectedDate) {
                                              const date = new Date(
                                                selectedDate
                                              );
                                              const today = new Date();
                                              today.setHours(0, 0, 0, 0);
                                              date.setHours(0, 0, 0, 0);

                                              if (
                                                date.getTime() ===
                                                today.getTime()
                                              ) {
                                                dateToStore = "today";
                                              } else {
                                                dateToStore = selectedDate; // Keep ISO format
                                              }
                                            }

                                            // Prioritize estimated_test_due_date for editing
                                            if (
                                              order.estimated_test_due_date ||
                                              !order.test_due_duration
                                            ) {
                                              currentOrders[
                                                index
                                              ].estimated_test_due_date =
                                                dateToStore;
                                            } else {
                                              currentOrders[
                                                index
                                              ].test_due_duration = dateToStore;
                                            }
                                            setOrders(
                                              formatOrdersToString(
                                                currentOrders
                                              )
                                            );
                                          }}
                                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ktx-green focus:border-transparent text-gray-600"
                                          disabled={status === "Locked"}
                                        />
                                      </div>
                                      <div className="col-span-2 flex justify-center">
                                        <button
                                          type="button"
                                          onClick={() => {
                                            if (status === "Locked") return;
                                            const currentOrders =
                                              parseOrdersFromString(
                                                orders || ""
                                              );
                                            currentOrders.splice(index, 1);
                                            setOrders(
                                              formatOrdersToString(
                                                currentOrders
                                              )
                                            );
                                          }}
                                          className={`p-2 rounded-md transition-colors ${
                                            status === "Locked"
                                              ? "text-gray-300 cursor-not-allowed"
                                              : "text-red-500 hover:text-red-700 hover:bg-red-50"
                                          }`}
                                          title={
                                            status === "Locked"
                                              ? "Cannot delete - order is locked"
                                              : "Delete order"
                                          }
                                          disabled={status === "Locked"}
                                        >
                                          <svg
                                            className="w-5 h-5"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade text-accent1 text-xl font-bold "
                    id={`id${patient.patient_id}nav-diarized`}
                    role="tabpanel"
                    aria-labelledby="nav-diarized=transcript-tab"
                  >
                    {/* <button
                        className="float-end mb-3 rounded-lg  text-accent1 p-2 text-sm mr-5 flex items-center"
                        onClick={handleTranscriptDownload}
                        disabled={!diarizedTranscriptCsvUrl}
                      >
                        <svg
                          class="w-6 h-6 text-accent1 dark:text-white mr-1"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
                          />
                        </svg>
                        Download Transcript CSV
                      </button> */}
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-accent1 text-xl font-bold">
                        Transcript
                      </span>
                      {selectedSectionWords.length > 0 && (
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-gray-600 bg-yellow-100 px-2 py-1 rounded">
                            Highlighting {selectedSectionWords.length} words
                            from selected section
                          </span>
                          <button
                            onClick={clearHighlighting}
                            className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded transition-colors"
                            title="Clear highlighting"
                          >
                            Clear
                          </button>
                        </div>
                      )}
                    </div>
                    <div
                      className="form-control resize-none mb-4 mt-2 rounded-md border-0 shadow-knowtex-shadow bg-secondary-grey p-3 overflow-y-auto whitespace-pre-wrap"
                      style={{
                        height: "480px",
                        fontFamily: "monospace",
                        fontSize: "14px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: (() => {
                          const content =
                            highlightedTranscript || diarizedTranscript || "";

                          // If we have highlighted content, it already contains HTML
                          if (
                            highlightedTranscript &&
                            highlightedTranscript.length > 0
                          ) {
                            // Content has highlighting HTML, preserve line breaks
                            return content.replace(/\n/g, "<br>");
                          } else {
                            // Content is plain text, apply full formatting
                            return content
                              .replace(/\n/g, "<br>")
                              .replace(/ {2}/g, "&nbsp;&nbsp;");
                          }
                        })(),
                      }}
                    />
                  </div>
                  <div
                    className="tab-pane fade"
                    id={`id${patient.patient_id}nav-summary`}
                    role="tabpanel"
                    aria-labelledby="nav-summary-tab"
                  >
                    <div className="text-accent1 text-xl font-bold flex justify-between items-center mb-3">
                      <span>Patient Visit Summary</span>
                      <CopyToClipboard
                        text={patientSummary || ""}
                        onCopy={() => {
                          setCopiedSummary(true);
                          setTimeout(() => setCopiedSummary(false), 2000);
                        }}
                      >
                        {copiedSummary ? (
                          <div className="text-success text-sm">✓ Copied!</div>
                        ) : (
                          <div className="flex items-center">
                            <img
                              src={clipboard}
                              width="20"
                              height="20"
                              alt="copy"
                              className="mr-1 hover:cursor-pointer"
                            />
                            <span className="text-accent1 text-sm hover:cursor-pointer">
                              Copy
                            </span>
                          </div>
                        )}
                      </CopyToClipboard>
                    </div>
                    <textarea
                      type="text"
                      readOnly
                      className="form-control resize-none mb-4 rounded-md border-0 shadow-knowtex-shadow bg-secondary-grey w-full"
                      value={
                        patientSummary ||
                        "No patient visit summary generated for this note."
                      }
                      rows={30}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {status === "Review" ? generateRecordLink(patient) : null}

              {/* Cancel button if status === "Review" */}
              {status === "Review" && (
                <button
                  type="button"
                  className="bg-transparent-grey text-knowtex-grey pl-10 pr-10 pt-2 pb-2 rounded-md font-medium mr-4"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    // Reset state logic, close modal, etc.
                    setDescription(patient.description);
                    setNote(patient.note);
                    setCodingInfo(patient.coding_information);
                    setLOSCode(patient.los_code);
                    log_review_note(patient.patient_id);
                    setEncounterTime(patient.time_spent);
                    setTimeBasedCode(patient.time_based_code);
                    setICD_10_codes(patient.icd_10_codes);
                    setOrders(patient.orders);
                    setIsCopied(false);
                    setIsEditing(false);
                    setDiarizedTranscript(patient.diarized_transcript);
                    setDiarizedTranscriptCsvUrl(
                      patient.diarized_transcript_csv_url
                    );
                    setCPT_codes(patient.cpt_codes);
                    setHCC_Codes(patient.hcc_codes);
                    setSelectedCodes(selectedCodes);

                    // Reset PAIN SCORE and PHQ data
                    setPainScore(painScore || "");
                    setPainScoreChecks(
                      painScoreChecks || {
                        noaction: false,
                        education: false,
                        relaxation: false,
                        applyHeat: false,
                        applyIce: false,
                        reassessPain: false,
                        cognitiveBehavioralTherapy: false,
                        continueCurrentPainRegimen: false,
                        recommendOTC: false,
                        prescribedCOX2: false,
                        prescribedAnxiolytic: false,
                        prescribedAntidepressant: false,
                        prescribedSteroidalAntiInflammatory: false,
                        prescribedOpioids: false,
                        referToPainManagement: false,
                        referToRadiationTherapy: false,
                        referToPalliativeCare: false,
                        other: false,
                      }
                    );
                    setPainScoreOther(painScoreOther || "");
                    setReassessPainInterval(reassessPainInterval || "");
                    setRecommendOTCDetails(recommendOTCDetails || "");
                    setPrescribedCOX2Details(prescribedCOX2Details || "");
                    setPrescribedAnxiolyticDetails(
                      prescribedAnxiolyticDetails || ""
                    );
                    setPrescribedAntidepressantDetails(
                      prescribedAntidepressantDetails || ""
                    );
                    setPrescribedSteroidalDetails(
                      prescribedSteroidalDetails || ""
                    );
                    setPrescribedOpioidsDetails(prescribedOpioidsDetails || "");
                    // Make sure to preserve the tilde character in PHQ score
                    setPhqScore(phqScore || "");
                    setPhqChecks(
                      phqChecks || {
                        supportEducate: false,
                        encourageAerobicActivity: false,
                        behavioralActivation: false,
                        referToSocialWork: false,
                        referToChaplaincy: false,
                        referToMentalHealthSpecialist: false,
                        referToIntegrativeMedicine: false,
                        continueCurrentAntidepressant: false,
                        prescribedAntidepressant: false,
                        other: false,
                      }
                    );
                    setPhqOther(phqOther || "");
                    //handleTrigger();
                  }}
                >
                  Cancel
                </button>
              )}
              {showUnspecifiedAlert && (
                <div
                  className="modal fade show"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  aria-modal="true"
                  role="dialog"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title text-accent1">
                          Unspecified Code Found
                        </h5>
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={() => setShowUnspecifiedAlert(false)}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body text-accent1">
                        <p>
                          You have "anemia, unspecified" as one of your codes.
                          Please review this code and select a more specific
                          code to upload this note to OncoEMR.
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            // If you want them to directly jump to the code tab or highlight the code,
                            // handle that logic here. For example, switch tabs or highlight the code field.

                            setShowUnspecifiedAlert(false);
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {patient.status !== "Locked" &&
                isCurrentCustomer.includes(superOrg) && (
                  <>
                    {/* Upload EMR button */}
                    <button
                      type="button"
                      className="bg-accent2 hover:bg-purple2 text-white py-2 px-4 rounded font-bold mr-2"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        // If user is NOT in dontShowCodes and anemia is present, show the alert
                        // if (
                        //   !dontShowCodes.includes(superOrg) &&
                        //   hasUnspecifiedIronDeficiencyAnemia()
                        // ) {
                        //   setShowUnspecifiedAlert(true);
                        // } else {
                        //   // Otherwise, just proceed
                        //   saveNoteOnly(patient.patient_id);
                        //   setIsCopied(false);
                        //   setIsEditing(false);
                        // }
                        saveNoteOnly(patient.patient_id);
                        setIsCopied(false);
                        setIsEditing(false);
                      }}
                    >
                      Save & Upload to EMR
                    </button>
                  </>
                )}
              {/* 2. If superOrg is NOT in isCurrentCustomer, show only Save (calls saveNoteOnly), hides Upload EMR.*/}
              {patient.status !== "Locked" && (
                <button
                  type="button"
                  className="bg-accent2 hover:bg-purple2 text-white py-2 px-4 rounded font-bold mr-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    editText(patient.patient_id);
                    setIsCopied(false);
                    setIsEditing(false);
                    sendServerLogging({
                      body: {
                        ...userJSON(localStorage.getItem("userName")),
                        event: "SAVED_NOTE",
                        eventData: { mrn: patient.mrn },
                        patientId: patient.patient_id,
                      },
                    });
                  }}
                >
                  Save Changes
                </button>
              )}
              {/* 2. If superOrg is Ironwood or Tenonc, show integuru Upload to EMR button*/}
              {patient.status !== "Locked" &&
                (superOrg === "Ironwood" || superOrg === "TenOnc") && (
                  <button
                    type="button"
                    className="bg-accent2 hover:bg-purple2 text-white py-2 px-4 rounded font-bold mr-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      editText(patient.patient_id);
                      changeStatusToLocked();
                      sendSlackNotification("notification", {
                        error_message: `User ${name} clicked Upload to EMR`,
                        status_code: 200,
                      });
                      integuruGetAccessTokenAndSendNote();
                      setIsCopied(false);
                      setIsEditing(false);
                    }}
                  >
                    Save and Upload to EMR
                  </button>
                )}

              {/* 2. If superOrg is Ironwood, show integuru reupload Upload to EMR button*/}
              {patient.status === "Locked" &&
                (superOrg === "Ironwood" || superOrg === "TenOnc") && (
                  <button
                    type="button"
                    className="bg-accent2 hover:bg-purple2 text-white py-2 px-4 rounded font-bold mr-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      editText(patient.patient_id);
                      changeStatusToLocked();
                      sendSlackNotification("notification", {
                        error_message: `User ${name} clicked Upload to EMR`,
                        status_code: 200,
                      });
                      integuruGetAccessTokenAndSendNote();
                      setIsCopied(false);
                      setIsEditing(false);
                    }}
                  >
                    Re-Upload to EMR
                  </button>
                )}

              {patient.status === "Locked" &&
                (superOrg === "Knowtex" || superOrg === "VA") && (
                  <button
                    type="button"
                    className="bg-accent2 hover:bg-purple2 text-white py-2 px-4 rounded font-bold mr-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      editText(patient.patient_id);
                      changeStatusToLocked();
                      changeEHRStatusToUploading();
                      setTimeout(() => {
                        changeEHRStatusToSuccess();
                      }, 5000);
                    }}
                  >
                    Re-Upload to EMR
                  </button>
                )}

              {status === "Locked" ? (
                <button
                  type="button"
                  className={css.save}
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setDescription(patient.description);
                    setNote(patient.note);
                    setPatientData(patientData);
                    setSelectedCodes(selectedCodes);
                    setCodingInfo(patient.coding_information);
                    setLOSCode(patient.los_code);
                    log_review_note(patient.patient_id);
                    setEncounterTime(patient.time_spent);
                    setTimeBasedCode(patient.time_based_code);
                    setICD_10_codes(patient.icd_10_codes);
                    setOrders(patient.orders);
                    setIsCopied(false);
                    setDiarizedTranscript(patient.diarized_transcript);
                    setDiarizedTranscriptCsvUrl(
                      patient.diarized_transcript_csv_url
                    );

                    // set isEditing back to false on close button
                    setIsEditing(false);
                  }}
                >
                  Done
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditPatient;
